export default class SnoballPageDesigner  {
    constructor(containerId, options) {
        this.toolbarExtended = false;
        this.containerId = containerId;
        this.options = options;
        this.variables = options.variables;
        this.imageUploadUrl = options.imageUploadUrl;
        this.cropImageUploadUrl = options.cropImageUploadUrl;
        this.authToken = options.authToken;
        this.onReadyCallback = null;
        this.ready = false;
        this.interval = null;
        this.styles = [];
        this.customJs = [];
        this.customStyleSheet = {};
        this.customCSS = '';
        this.webFontLoadMonitorInstalled = false;
        this.videoUploadUrl = null;
        this.editorHeight = null;
        this.imageAutoCropEnabled = options.imageAutoCropEnabled;
        this.imageProcessLimits = options.imageProcessLimits || null;
        this.onVariablePickerRequested = null;
        // (origin, color, change) => panel: the app opens its colour panel for the block background colour.
        this.onColorPickerRequested = null;
        this.colorPicker = null;
        this._pendingEditor = null;
        this._pendingContext = null;

        document.querySelector('#' + containerId).classList.add('snoball-page-designer');
        if (this.optionHasValue(options, 'styles')) {
          this.styles = options.styles;
        }
        if (this.optionHasValue(options, 'customJs')) {
          this.customJs = options.customJs;
        }
        this.froala = this.initFroala(containerId, options.froalaLicenseKey);

        if (this.optionHasValue(options, 'blocksSelectorContainerElementId')) {
            document.querySelectorAll('#' + options.blocksSelectorContainerElementId + ' .block').forEach((element) => {
                element.addEventListener("click", this.blockSelectorCallback.bind(this));
            });
        }

        if (this.optionHasValue(options, 'deviceSizeSelectorContainerElementId')) {
            document.querySelectorAll('#' + options.deviceSizeSelectorContainerElementId + ' > .fp-btn').forEach((element) => {
                element.addEventListener("click", this.devicesSizeSelectorCallback.bind(this));
            });
        }
        if (this.optionHasValue(options, 'onReadyCallback')) {
          this.onReadyCallback = options.onReadyCallback;
        }
    }

    setVariables(val) {
      this.variables = val;
      this.extendFroalaToolbar();
    }

    setImageAutoCropEnabled(val) {
      this.imageAutoCropEnabled = val;
      this.refreshFroala();
    }

    setImageProcessLimits(val) {
      this.imageProcessLimits = val;
      this.refreshFroala();
    }

    requestVariablePicker(context, editorInstance) {
      this._pendingContext = context;
      this._pendingEditor = editorInstance;
      if (this.onVariablePickerRequested) {
        this.onVariablePickerRequested(context);
      }
    }

    handleVariableSelected(variable) {
      const context = this._pendingContext;
      const editor = this._pendingEditor;
      const key = typeof variable === 'string' ? variable : variable.key;
      const name = typeof variable === 'string' ? variable : (variable.name || variable.key);

      if (context === 'image') {
        if (this.froala && this.froala.editor) {
          this.froala.editor.handleImageVariableSelected(key, name);
        }
        this._pendingContext = null;
        this._pendingEditor = null;
        return;
      }

      if (!editor || !context) return;

      if (context === 'text') {
        editor.selection.restore();
        if (key === '#InfluencerSessionsList#') {
          editor.html.insert(`<div>${key}</div>`);
        } else {
          editor.html.insert(key);
        }
      } else if (context === 'linkUrl') {
        var $popup = editor.popups.get('link.insert');
        var urlInput = $popup.find("input");
        if (urlInput && urlInput[0]) {
          urlInput[0].value = key;
          urlInput[0].focus();
        }
      } else if (context === 'linkText') {
        var $popup = editor.popups.get('link.insert');
        var textInput = $popup.find(`#fr-link-insert-layer-text-${editor.id}`);
        if (textInput && textInput[0]) {
          textInput[0].value = key;
          textInput[0].focus();
        }
      }

      this._pendingContext = null;
      this._pendingEditor = null;
    }

    optionHasValue(options, key) {
        return !!(options.hasOwnProperty(key) && options[key]);
    }

    initFroala(containerId, licenseKey) {
        var that = this;
        let options = {
            showDownloadCounter: false,
            editorOptions: {
                variables: this.variables,
                imageAutoCropEnabled: this.imageAutoCropEnabled,
                colorsHEXInput: true,
                toolbarButtons: ['variables'],
                linkInsertButtons: ["linkBack", "|", "linkUrlVariables"], // linkList, linkTextVariables
                imageUploadURL: this.imageUploadUrl,
                videoMaxSize: 200 * 1024 * 1024,
                cropImageUploadUrl: this.cropImageUploadUrl,
                requestHeaders: {
                  'Authorization': `Bearer ${this.authToken}`
                },
                htmlUntouched: true,
                pastePlain: true,
                placeholderText: '',
                events: {
                  'image.uploaded': function (response) {
                    const jsonResponse = JSON.parse(response);
                    this.image.insert(jsonResponse.data.url, false, null, this.image.get(), response);
                    return false;
                  },
                  'video.beforeUpload': function (e, editor, videos) {
                    let beforeUploadInstance = this;
                    const fileData = e[0];
                    const xhttp = new XMLHttpRequest();
                    const fileName = e[0]['name'];
                    const contentType = e[0]['type'];
                    const params = `?fileName=${fileName}&contentType=${contentType}`;
                    const url = that.imageUploadUrl + "/get-signed-url" + params;
                    xhttp.onreadystatechange = function() {
                      if (this.readyState == 4 && this.status == 200) {
                        const response =  JSON.parse(xhttp.responseText);
                        if(response) {
                          uploadToSignedUrl(response);
                        }
                      }
                    };
                    xhttp.open("GET", url, true);
                    xhttp.setRequestHeader('Authorization', `Bearer ${that.authToken}` );
                    xhttp.send(null );
                    function uploadToSignedUrl(response) {
                      const xhttpUpload = new XMLHttpRequest();
                      xhttpUpload.onreadystatechange = function() {
                        if (this.readyState == 4 && this.status == 200) {
                          setTimeout(function () {
                            // console.log('===beforeUploadInstance',beforeUploadInstance.video.get())
                            // const videoTag = beforeUploadInstance.video.get()[0].querySelector("video");
                            // const videoTag = beforeUploadInstance.el.querySelector('video');
                            const videoTag = that.froala.editor.FroalaEditor.SELECTED_TARGET.querySelector('video');
                            const eleSrc = response.data.url.split('?')[0];
                            videoTag.setAttribute('src',eleSrc);
                          },20)
                        }
                      };
                      xhttpUpload.open("PUT", response.data.url, true);
                      xhttpUpload.setRequestHeader( 'Skip-auth' , 'true');
                      xhttpUpload.setRequestHeader( 'Content-Type' , fileData.type);
                      xhttpUpload.send(fileData);
                    }
                  },
                  'video.error': function (error, response) {
                    if(error.code == 5) {
                      var popup = this.popups.get('video.insert');
                      var layer = popup.find('.fr-video-progress-bar-layer');
                      layer.find('h3').text('Video cannot be larger than 200MB.');
                    }
                   return false;
                  },
                  'popups.show.textColor.picker': function () {
                    that.applyColors(this.doc.body.innerHTML, this.opts.colorsText, this.opts.colorsStep,
                      'applytextColor', this, 'textColor.picker', '.fr-text-color');
                  },
                  'popups.show.backgroundColor.picker': function () {
                    that.applyColors(this.doc.body.innerHTML, this.opts.colorsBackground, this.opts.colorsStep,
                      'applybackgroundColor', this, 'backgroundColor.picker', '.fr-background-color');
                  },
                  'popups.show.customButtonColorText.picker': function () {
                    that.applyColors(this.doc.body.innerHTML, this.opts.colorsText, this.opts.colorsStep,
                      'applyButtontextColor', this, 'customButtonColorText.picker', '.fr-text-color');
                  },
                  'popups.show.customButtonColorBackground.picker': function () {
                    that.applyColors(this.doc.body.innerHTML, this.opts.colorsBackground, this.opts.colorsStep,
                      'applyButtonbackgroundColor', this, 'customButtonColorBackground.picker', '.fr-background-color');
                  },
                  'popups.show.customButtonColorBackgroundHover.picker': function () {
                    that.applyColors(this.doc.body.innerHTML, this.opts.colorsBackground, this.opts.colorsStep,
                      'applyButtonbackgroundHoverColor', this, 'customButtonColorBackgroundHover.picker', '.fr-backgroundHover-color');
                  },
                  'popups.show.customButtonColorBorder.picker': function () {
                    that.applyColors(this.doc.body.innerHTML, this.opts.colorsBackground, this.opts.colorsStep,
                      'applyButtonborderColor', this, 'customButtonColorBorder.picker', '.fr-border-color');
                  },
                  'popups.show.link.edit': function () {
                    let element;
                    if (that.froala.editor.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
                      element = that.froala.editor.FroalaEditor.SELECTED_TARGET;
                    } else {
                      element = that.froala.editor.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
                    }
                    let ele = this.popups.get('link.edit')[0].querySelector('.fr-command.fr-btn[data-cmd="backgroundHoverColorButton"]');
                    if (element.classList.contains('btn')) {
                      ele.classList.remove('d-none');
                    } else {
                      ele.classList.add('d-none');
                    }
                    ele = this.popups.get('link.edit')[0].querySelector('.fr-command.fr-btn[data-cmd="backgroundBorderButton"]');
                    if (element.classList.contains('btn')) {
                      ele.classList.remove('d-none');
                    } else {
                      ele.classList.add('d-none');
                    }
                  },
                  'contentChanged': function () {
                    that.refreshSize();
                    if (that.onContentChanged) that.onContentChanged();
                  },
                    'videoAllowedProviders':['youtube'],
                    'video.linkError': function (link) {
                        // Do something here.
                        // this is the editor instance.
                        console.log(this);
                    }
                }
            },
            //blockButtons: ['remove']
            designJavascripts: [
                'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js',
                //'https://code.jquery.com/jquery-3.3.1.slim.min.js',
                //'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js',
                //'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js',
                //'https://cdn.jsdelivr.net/npm/froala-editor/js/froala_editor.pkgd.min.js',
                //'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/all.min.js',
                //'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js'
                ...this.customJs
            ],
            designStylesheets: this.styles,
            /*
            designStylesheets: [
                'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css',
                'https://cdn.jsdelivr.net/gh/froala/design-blocks@master/dist/css/froala_blocks.min.css',
                'https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i',
                'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
                'https://cdn.jsdelivr.net/npm/froala-editor/css/froala_editor.pkgd.min.css',
                'https://cdn.jsdelivr.net/npm/froala-editor/css/froala_style.min.css',
                'https://uicdn.toast.com/tui-color-picker/latest/tui-color-picker.css'
            ],
            */
            designsDefaultBlocks: "Custom" //The default one tags are available even if the panel is not open. so don't change it since the dynamic add block depends on it
        };
        if (licenseKey) {
            options.key = licenseKey; //Place your key after downloading from https://froala.com/pages,
        }

        options.eventCallbacks = {
          'emptyBlock.afterAdd': (froala) => {
            froala.iframeDoc.querySelector('.fp-no-block h1').innerHTML = 'Blank Template';
            froala.iframeDoc.querySelector('.fp-no-block p').innerHTML = '(click on the blocks on the left side to add them here)';
          },
          'emptyBlock.click': () => {
            this.froala.setView(2);
          },
          'init.renderBeforeRefresh': (froala) => {
            this.froala = froala;
            this.addCssToFroala();
            this.extendFroalaToolbar();
            this.onReady();
          },
          'init.renderAfter': (froala) => {
            this.afterRender();
          },
          'block.inserted': (block) => {
            this.refreshFroala();
            this.initBlockSettings();
            if (this.onContentChanged) this.onContentChanged();
            if (this.editorHeight) {
              this.setEditorHeight(null, true);
            }
            block.el.addEventListener('click', () => {
              this.hideColorPicker();
              let blockSettings = $(".custom-block-settings");
              if (blockSettings && !blockSettings.hasClass('es-hidden')) {
                blockSettings.editorSettings("hide");
              }
              return false;
            });
          },
          'block.removed': (block) => {
            if (this.editorHeight) {
              this.setEditorHeight(null, true);
            }
            if (this.onContentChanged) this.onContentChanged();
          },
          'button.refreshed': (activeBlock) => {
            this.initColorLib();
            if (this.colorPicker) {
              this.colorPicker.updatePosition();
            }
            $(".custom-block-settings").editorSettings("reflow").editorSettings("updateBlockValue", activeBlock);
          },
          'button.hidden': () => {
            this.hideColorPicker();
            $(".custom-block-settings").editorSettings("hide");
          },
        };
        return new FroalaPages(containerId, options);
    }

    applyColors(html, defaultColors, numberOfColumns, command, editor, popupName, findClass) {
      let colors = this.extractColors(html, defaultColors);
      let defaultColorHtml = this.getColorsHtml(defaultColors, numberOfColumns, command);
      colors = this.getColorsHtml(colors, numberOfColumns, command);
      let element = editor.popups.get(popupName)[0].querySelector(findClass);
      element.innerHTML = `${defaultColorHtml}${colors.length > 0 ? '<hr>': ''}${colors}`;
      let popUp = editor.popups.get(popupName);
      let m = editor;
      let r = this?.froala?.editor?.FroalaEditor?.SELECTED_TARGET;
      let t = command.includes('backgroundColor') ? 'background-color' : 'color';
      let o = popUp.find(".fr-".concat('select-color[data-param1="').concat(m.helpers.RGBToHex(r.style[t]), '"]'));
      o.append('<span class="fr-selected-color" aria-hidden="true"><i class="fa fa-check" aria-hidden="true"></i></span>'); o.addClass("fr-active-item").attr("aria-selected", !0);
    }

    initColorLib() {
      document.querySelectorAll('.custom-color-picker').forEach((element) => {
        element.onclick = (event) => {
          event.stopPropagation();
          this.openColorPicker(element);
        };
      });
    }

    // The active block's background colour as #rrggbb, or '' when it has none.
    activeBlockBackgroundColor() {
      let savedColor = '';
      if(this.froala.activeBlock?.el.style.backgroundColor) {
        let activeBackgroundColor = this.froala.activeBlock.el.style.backgroundColor;
        activeBackgroundColor = activeBackgroundColor.slice(
          activeBackgroundColor.indexOf('(') + 1,
          activeBackgroundColor.lastIndexOf(')'),
        ).split(', ');

        if (activeBackgroundColor.length > 2) {
          savedColor = rgbToHex(Number(activeBackgroundColor[0]), Number(activeBackgroundColor[1]), Number(activeBackgroundColor[2]));
          function componentToHex(c) {
            var hex = c.toString(16);
            return hex.length == 1 ? "0" + hex : hex;
          }
          function rgbToHex(r, g, b) {
            return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
          }
        }
      }
      return savedColor;
    }

    // The toolbar's background colour button opens the app's colour panel; a chosen colour goes to the block.
    openColorPicker(element) {
      if (!this.onColorPickerRequested || (this.colorPicker && this.colorPicker.isOpen)) {
        return;
      }
      $(".custom-block-settings").editorSettings("hide");
      this.colorPicker = this.onColorPickerRequested(element, this.activeBlockBackgroundColor(), (hex) => {
        element.value = hex;
        this.froala.events.emit('color.change');
      });
    }

    hideColorPicker() {
      if (this.colorPicker) {
        this.colorPicker.close();
        this.colorPicker = null;
      }
    }

    initBlockSettings() {
      let blockSettings = $(".custom-block-settings");
      blockSettings.editorSettings({
        appendTo: '#block_setting_container',
        elements: ['height', 'margin-top', 'margin-left', 'margin-bottom', 'margin-right',
          'padding-top', 'padding-left', 'padding-bottom', 'padding-right', 'background-size', 'aspect-ratio', 'background-repeat'],
        change: (values, elements) => {
          this.froala.events.emit('block.setting', values, elements)
        },
        beforeShow: () => {
          this.hideColorPicker();
        }
      });
    }

    extractColors(content, duplicate) {
      let html = content + this.customStyleSheetToString() + this.getCustomCSSStyles();
      let colors = [...html.matchAll(/color:[^;][#0-9a-zA-Z(, )]*/g)];
      colors = colors.map(item => {
        let str = item[0];
        str = str.replace('color:', '').trim();
        if (str.startsWith('#') || str.startsWith('rgb')) {
          if (str.startsWith('rgb')) {
            str = str.match(/[0-9|.]+/g).map((x,i) => i === 3 ? parseInt(255 * parseFloat(x)).toString(16) : parseInt(x).toString(16)).join('')
          }
          str = str.replace('#', '');
          if (str.length === 3) {
            str = str.split('').map(function (hex) {
              return hex + hex;
            }).join('');
          }
          return '#' + str;
        }
        return null;
      }).filter(item => item);
      duplicate = duplicate.map(item => item.toLowerCase());
      colors = colors.filter(val => !duplicate.includes(val.toLowerCase()))
      colors = [...new Set(colors)];
      return colors;
    }

    getColorsHtml(colors, size, command) {
      colors = colors.map(item => {
        let title = `title="${item}"`;
        let svg = '';
        if (item === 'REMOVE') {
          title = `title="Clear Formatting"`
          svg = `<svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z"></path></svg>`;
        }
        return `<span class="fr-command fr-select-color" style="background:${item};" ${title} tabindex="-1" aria-selected="false" role="button" data-cmd="${command}" data-param1="${item}">
                ${svg}<span class="fr-sr-only"> ${item === 'REMOVE' ? 'Clear Formatting' : 'Color ' + item}</span></span>`;
      })
      let chunkedColors = [...Array(Math.ceil(colors.length / size))].map(_ => colors.splice(0, size));
      return chunkedColors.map(item => `${item.join('')}<br />`).join('');
    }

    afterRender() {
      if (!this.froala) return;
      if (this.froala.iframeDoc.defaultView.FroalaEditor) {
        this.refreshFroala();
        this.extendFroalaToolbar();
      } else {
        setTimeout(() => {
          this.afterRender();
        }, 1000);
      }
    }

    setEditorHeight(height, refreshIframeSize) {
      this.editorHeight = height || this.editorHeight;
      let remainHeight = this.editorHeight;

      if (this.froala && this.froala.iframeDoc.defaultView.FroalaEditor) {
        const elements = this.froala.iframeDoc.querySelectorAll('section, header, footer');
        elements.forEach((element, index) => {
          if (index === elements.length - 1) {
            element.style.height = `${remainHeight}px`;
          } else {
            element.style.height = 'auto';
            if (element.offsetHeight) {
              let orgHeight = element.offsetHeight;
              const height = Math.min(remainHeight, orgHeight);
              element.style.height = `${height}px`;
              remainHeight -= height;
            }
          }
        });

        if (refreshIframeSize) {
          const el = document.querySelector('#froala-pages');
          if (el) {
            el.style.height = `${this.editorHeight}px`;
          }
        }
      }
    }

    onReady() {
      this.ready = true;
      this.froala.editor.disable();
      document.dispatchEvent(new CustomEvent('PageDesignerReady'));
      if (this.onReadyCallback) {
        this.onReadyCallback(this);
      }
    }

    disableEditor() {
      this.froala.editor.disable();
    }

    enableEditor() {
      if (!this.froala) return;
      if (this.froala.editor && this.froala.iframeDoc.defaultView.FroalaEditor) {
        this.froala.editor.enable(this.variables, this.imageAutoCropEnabled, this.imageProcessLimits);
      } else {
        setTimeout(() => {
          this.enableEditor()
        }, 500);
      }
    }

    destroy() {
      this.hideColorPicker();
      document.querySelectorAll('.fp-block-toolbar').forEach((element) => {
        // element.style.display = 'none';
        element.remove();
      })
      if (this.interval) {
        window.clearInterval(this.interval);
      }
      this.froala = null;
    }

    resetContent() {
      this.froala._initIframe();
    }

    setHtml(htmlParts, callBack) {
      if (!this.ready) {
        // Listen for the event.
        document.addEventListener('PageDesignerReady', (e) => { this.setHtml(htmlParts) }, false);
      } else {
        this.resetContent();
        let doc = new DOMParser().parseFromString('<html>' + htmlParts.body + '</html>', 'text/html');
        let sections = doc.querySelectorAll('body > [data-block-type]');
        // Render each blocks into view
        for (var i = 0; i < sections.length; i++) {
          this.appendBlock(sections[i].outerHTML, sections[i].getAttribute('data-block-type'), false);
        }
        /*
        this.froala.setHTML(`
          <html>
              <head>
                  <style type="text/css">svg:not(:root).svg-inline--fa{overflow:visible}.svg-inline--fa{display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-.125em}.svg-inline--fa.fa-lg{vertical-align:-.225em}.svg-inline--fa.fa-w-1{width:.0625em}.svg-inline--fa.fa-w-2{width:.125em}.svg-inline--fa.fa-w-3{width:.1875em}.svg-inline--fa.fa-w-4{width:.25em}.svg-inline--fa.fa-w-5{width:.3125em}.svg-inline--fa.fa-w-6{width:.375em}.svg-inline--fa.fa-w-7{width:.4375em}.svg-inline--fa.fa-w-8{width:.5em}.svg-inline--fa.fa-w-9{width:.5625em}.svg-inline--fa.fa-w-10{width:.625em}.svg-inline--fa.fa-w-11{width:.6875em}.svg-inline--fa.fa-w-12{width:.75em}.svg-inline--fa.fa-w-13{width:.8125em}.svg-inline--fa.fa-w-14{width:.875em}.svg-inline--fa.fa-w-15{width:.9375em}.svg-inline--fa.fa-w-16{width:1em}.svg-inline--fa.fa-w-17{width:1.0625em}.svg-inline--fa.fa-w-18{width:1.125em}.svg-inline--fa.fa-w-19{width:1.1875em}.svg-inline--fa.fa-w-20{width:1.25em}.svg-inline--fa.fa-pull-left{margin-right:.3em;width:auto}.svg-inline--fa.fa-pull-right{margin-left:.3em;width:auto}.svg-inline--fa.fa-border{height:1.5em}.svg-inline--fa.fa-li{width:2em}.svg-inline--fa.fa-fw{width:1.25em}.fa-layers svg.svg-inline--fa{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.fa-layers{display:inline-block;height:1em;position:relative;text-align:center;vertical-align:-.125em;width:1em}.fa-layers svg.svg-inline--fa{-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter,.fa-layers-text{display:inline-block;position:absolute;text-align:center}.fa-layers-text{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter{background-color:#ff253a;border-radius:1em;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;height:1.5em;line-height:1;max-width:5em;min-width:1.5em;overflow:hidden;padding:.25em;right:0;text-overflow:ellipsis;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-bottom-right{bottom:0;right:0;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom right;transform-origin:bottom right}.fa-layers-bottom-left{bottom:0;left:0;right:auto;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom left;transform-origin:bottom left}.fa-layers-top-right{right:0;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-top-left{left:0;right:auto;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top left;transform-origin:top left}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-.0667em}.fa-xs{font-size:.75em}.fa-sm{font-size:.875em}.fa-1x{font-size:1em}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-6x{font-size:6em}.fa-7x{font-size:7em}.fa-8x{font-size:8em}.fa-9x{font-size:9em}.fa-10x{font-size:10em}.fa-fw{text-align:center;width:1.25em}.fa-ul{list-style-type:none;margin-left:2.5em;padding-left:0}.fa-ul>li{position:relative}.fa-li{left:-2em;position:absolute;text-align:center;width:2em;line-height:inherit}.fa-border{border:solid .08em #eee;border-radius:.1em;padding:.2em .25em .15em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left,.fab.fa-pull-left,.fal.fa-pull-left,.far.fa-pull-left,.fas.fa-pull-left{margin-right:.3em}.fa.fa-pull-right,.fab.fa-pull-right,.fal.fa-pull-right,.far.fa-pull-right,.fas.fa-pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.fa-rotate-90{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-webkit-transform:scale(-1,1);transform:scale(-1,1)}.fa-flip-vertical{-webkit-transform:scale(1,-1);transform:scale(1,-1)}.fa-flip-both,.fa-flip-horizontal.fa-flip-vertical{-webkit-transform:scale(-1,-1);transform:scale(-1,-1)}:root .fa-flip-both,:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-rotate-90{-webkit-filter:none;filter:none}.fa-stack{display:inline-block;height:2em;position:relative;width:2.5em}.fa-stack-1x,.fa-stack-2x{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.svg-inline--fa.fa-stack-1x{height:1em;width:1.25em}.svg-inline--fa.fa-stack-2x{height:2em;width:2.5em}.fa-inverse{color:#fff}.sr-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only-focusable:active,.sr-only-focusable:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}.svg-inline--fa .fa-primary{fill:var(--fa-primary-color,currentColor);opacity:1;opacity:var(--fa-primary-opacity,1)}.svg-inline--fa .fa-secondary{fill:var(--fa-secondary-color,currentColor);opacity:.4;opacity:var(--fa-secondary-opacity,.4)}.svg-inline--fa.fa-swap-opacity .fa-primary{opacity:.4;opacity:var(--fa-secondary-opacity,.4)}.svg-inline--fa.fa-swap-opacity .fa-secondary{opacity:1;opacity:var(--fa-primary-opacity,1)}.svg-inline--fa mask .fa-primary,.svg-inline--fa mask .fa-secondary{fill:#000}.fad.fa-inverse{color:#fff}</style>
                  ${htmlParts.styles}
                  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/froala-editor/css/froala_editor.pkgd.min.css">
                  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/froala-editor/css/froala_style.min.css">
              </head>
              <body class="no-block fp-full-view">
                  <div class="fp-no-block fp-no-sections fp-visible" data-fp="true" style="display: flex;"><h1>Blank Template</h1><p>(click on the blocks on the left side to add them here)</p></div>
                  ${htmlParts.body}
              </body>
          </html>
        `);
         */
        this.addCssToFroala();
        this.froala.setView(2);
        setTimeout(() => {
          if (!this.froala) return;
          if (this.froala.hasOwnProperty('activeBlock')) {
            this.refreshFroala();
          }
          this.findAndApplyFonts(htmlParts.body);
          setTimeout(() => {
            if (!this.froala) return;
            if (callBack) {
              callBack();
              setTimeout(() => {
                this.refreshSize();
              }, 500);
            } else {
              this.refreshSize();
            }
          }, 1500);
        }, 1000);
      }
    }

  async getHtmlParts() {
      const result = {body: '', styles: ''};
      const json = await this.froala.getJSON();
      // const parts = await JSON.parse(json);
      result.body = json.blocks.join('');

      let styles = `<style type="text/css">
svg:not(:root).svg-inline--fa{overflow:visible}.svg-inline--fa{display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-.125em}.svg-inline--fa.fa-lg{vertical-align:-.225em}.svg-inline--fa.fa-w-1{width:.0625em}.svg-inline--fa.fa-w-2{width:.125em}.svg-inline--fa.fa-w-3{width:.1875em}.svg-inline--fa.fa-w-4{width:.25em}.svg-inline--fa.fa-w-5{width:.3125em}.svg-inline--fa.fa-w-6{width:.375em}.svg-inline--fa.fa-w-7{width:.4375em}.svg-inline--fa.fa-w-8{width:.5em}.svg-inline--fa.fa-w-9{width:.5625em}.svg-inline--fa.fa-w-10{width:.625em}.svg-inline--fa.fa-w-11{width:.6875em}.svg-inline--fa.fa-w-12{width:.75em}.svg-inline--fa.fa-w-13{width:.8125em}.svg-inline--fa.fa-w-14{width:.875em}.svg-inline--fa.fa-w-15{width:.9375em}.svg-inline--fa.fa-w-16{width:1em}.svg-inline--fa.fa-w-17{width:1.0625em}.svg-inline--fa.fa-w-18{width:1.125em}.svg-inline--fa.fa-w-19{width:1.1875em}.svg-inline--fa.fa-w-20{width:1.25em}.svg-inline--fa.fa-pull-left{margin-right:.3em;width:auto}.svg-inline--fa.fa-pull-right{margin-left:.3em;width:auto}.svg-inline--fa.fa-border{height:1.5em}.svg-inline--fa.fa-li{width:2em}.svg-inline--fa.fa-fw{width:1.25em}.fa-layers svg.svg-inline--fa{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.fa-layers{display:inline-block;height:1em;position:relative;text-align:center;vertical-align:-.125em;width:1em}.fa-layers svg.svg-inline--fa{-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter,.fa-layers-text{display:inline-block;position:absolute;text-align:center}.fa-layers-text{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter{background-color:#ff253a;border-radius:1em;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;height:1.5em;line-height:1;max-width:5em;min-width:1.5em;overflow:hidden;padding:.25em;right:0;text-overflow:ellipsis;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-bottom-right{bottom:0;right:0;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom right;transform-origin:bottom right}.fa-layers-bottom-left{bottom:0;left:0;right:auto;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom left;transform-origin:bottom left}.fa-layers-top-right{right:0;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-top-left{left:0;right:auto;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top left;transform-origin:top left}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-.0667em}.fa-xs{font-size:.75em}.fa-sm{font-size:.875em}.fa-1x{font-size:1em}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-6x{font-size:6em}.fa-7x{font-size:7em}.fa-8x{font-size:8em}.fa-9x{font-size:9em}.fa-10x{font-size:10em}.fa-fw{text-align:center;width:1.25em}.fa-ul{list-style-type:none;margin-left:2.5em;padding-left:0}.fa-ul>li{position:relative}.fa-li{left:-2em;position:absolute;text-align:center;width:2em;line-height:inherit}.fa-border{border:solid .08em #eee;border-radius:.1em;padding:.2em .25em .15em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left,.fab.fa-pull-left,.fal.fa-pull-left,.far.fa-pull-left,.fas.fa-pull-left{margin-right:.3em}.fa.fa-pull-right,.fab.fa-pull-right,.fal.fa-pull-right,.far.fa-pull-right,.fas.fa-pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.fa-rotate-90{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-webkit-transform:scale(-1,1);transform:scale(-1,1)}.fa-flip-vertical{-webkit-transform:scale(1,-1);transform:scale(1,-1)}.fa-flip-both,.fa-flip-horizontal.fa-flip-vertical{-webkit-transform:scale(-1,-1);transform:scale(-1,-1)}:root .fa-flip-both,:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-rotate-90{-webkit-filter:none;filter:none}.fa-stack{display:inline-block;height:2em;position:relative;width:2.5em}.fa-stack-1x,.fa-stack-2x{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.svg-inline--fa.fa-stack-1x{height:1em;width:1.25em}.svg-inline--fa.fa-stack-2x{height:2em;width:2.5em}.fa-inverse{color:#fff}.sr-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only-focusable:active,.sr-only-focusable:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}.svg-inline--fa .fa-primary{fill:var(--fa-primary-color,currentColor);opacity:1;opacity:var(--fa-primary-opacity,1)}.svg-inline--fa .fa-secondary{fill:var(--fa-secondary-color,currentColor);opacity:.4;opacity:var(--fa-secondary-opacity,.4)}.svg-inline--fa.fa-swap-opacity .fa-primary{opacity:.4;opacity:var(--fa-secondary-opacity,.4)}.svg-inline--fa.fa-swap-opacity .fa-secondary{opacity:1;opacity:var(--fa-primary-opacity,1)}.svg-inline--fa mask .fa-primary,.svg-inline--fa mask .fa-secondary{fill:#000}.fad.fa-inverse{color:#fff}
</style>`;
      let newStyles = [];
     json.style.forEach(item => {
        if (item && (item.indexOf('bootstrap') > -1 || item.indexOf('templates') > -1 || item.indexOf('froala_blocks') > -1 || item.indexOf('font-awesome') > -1 || item.indexOf('fonts.googleapis') > -1 || item.indexOf('froala_style') > -1)) {
          newStyles.push(item);
        }
      });
      newStyles = [...new Set(newStyles)];
      styles += newStyles.join("\n");
      result.styles = styles + this.customStyleSheetToString() + this.getCustomCSSStyles();

      return result;
    }

    // forces froala to re-run its script and show the toolbar
    refreshFroala() {
      setTimeout( () => {
        if (this.froala && this.froala.editor && this.froala.iframeDoc.defaultView) {
          // if (!this.froala.iframeDoc.querySelector('.fr-toolbar')) {
          //   let vals = Object.keys(this.variables).map(item => {
          //     return {label: this.variables[item].name, value: item};
          //   })
          this.extendFroalaToolbar();
          this.froala.editor.enable(this.variables, this.imageAutoCropEnabled, this.imageProcessLimits);
          // }
          this.froala.iframeDoc.querySelectorAll('section, header, footer').forEach((element) => {
            element.setAttribute('draggable', false);
          });
        }
      }, 10)
    }


    appendBlock(elementHtml, type, disableRefresh = true) {
        const block = {
          blockType: type.charAt(0).toUpperCase() + type.slice(1),
          template: elementHtml,
          render: function render(params) {
            return this.template.replace(/{{[a-zA-Z_]*}}/g, function (match) {
              var varName = match.replace(/{|}/g, '').trim();

              return params[varName] || '{{' + varName + '}}';
            });
          }
        }
        this.froala.insertBlock(block);
        if (disableRefresh)
          this.refreshFroala();
    }

    blockSelectorCallback(e) {
        //console.log(blockId);
        //console.log(elementHtml);
        let elementHtml = this.options.blocksSelectorCallback(e);
        window.snoballPageDesigner.appendBlock(elementHtml, 'custom');
    }

    devicesSizeSelectorCallback(e) {
        document.querySelectorAll('#' + this.options.deviceSizeSelectorContainerElementId + ' > .fp-active').forEach((element) => {
            element.classList.remove('fp-active');
        })
        let element = e.currentTarget;
        if (element.classList.contains('fp-desktop-btn')) {
            this.changeViewportSize('desktop');
            element.classList.add('fp-active');
        }
        if (element.classList.contains('fp-tablet_landscape-btn')) {
            this.changeViewportSize('tablet_landscape');
            element.classList.add('fp-active');
        }
        if (element.classList.contains('fp-tablet_portrait-btn')) {
            this.changeViewportSize('tablet_portrait');
            element.classList.add('fp-active');
        }
        if (element.classList.contains('fp-phone-btn')) {
            this.changeViewportSize('phone');
            element.classList.add('fp-active');
        }
    }

    /**
     * desktop, tablet_landscape, tablet_portrait, phone
     * @param targetSize
     */
    changeViewportSize(targetSize) {
      let view = '';
      switch (targetSize) {
        case 'desktop': view = 100; break;
        case 'tablet_landscape': view = 1024; break;
        case 'tablet_portrait': view = 768; break;
        case 'phone': view = 375; break;
      }
      // this.froala.setView(view);
      document.querySelector('#' + this.containerId + ' .fp-page-toolbar .fp-' + targetSize + '-btn').click();
    }

    findAndApplyFonts(html) {
      if (this.froala && this.froala.editor && this.froala.editor.FroalaEditor && this.froala.editor.FroalaEditor.DEFAULTS) {
        var defaultFontFamilies = Object.values(this.froala.editor.FroalaEditor.DEFAULTS.fontFamily)
          .map(t => t.trim());
        html = this.convertHTMLEntity(html);
        let fontFamilies = [...html.matchAll(/font-family:[#0-9a-zA-Z(, -)][^;]*/g)];
        fontFamilies.forEach(item => {
          let fontFamily = item[0];
          fontFamily = fontFamily.replace('font-family:', '').trim();
          fontFamily = fontFamily.split(',').map(f => f.replace(/"/g, '').trim()).join(', ');
          fontFamily = fontFamily.split(',');
          for (let i = 0; i < fontFamily.length; i++) {
            if (defaultFontFamilies.includes(fontFamily[i])) {
              this.loadGoogleFont(fontFamily[i]);
              break;
            }
          }
        })
      } else {
        setTimeout(() => {
          this.findAndApplyFonts(html);
        }, 500);
      }
    }

  convertHTMLEntity(text){
    const span = document.createElement('span');
    return text
      .replace(/&[#A-Za-z0-9]+;/gi, entity => {
        span.innerHTML = entity;
        return span.innerText;
      });
  }

    addCssToFroala() {
        let css = this.froala.iframeDoc.createElement("style");
        css.innerHTML = `
        body {
          overflow: hidden;
        }
        .fp-no-block {
          display: none;
          text-align: center;
          color: #000000;
          cursor: default;
          background-color: #DEDEDE;
        }
        body.no-block .fp-no-block {
          display: block;
        }

        .fp-active {
          display: block !important;
        }

        .fr-box.fr-inline .fr-wrapper .fr-element.fr-view ul.navbar-nav {
          display: flex !important;
        }

        .fr-box.fr-inline .fr-wrapper .fr-element.fr-view ul.navbar-nav {
          display: flex !important;
        }

        .fr-toolbar p {
          color: #222222 !important;
          font-family: Arial, Helvetica, sans-serif !important;
        }

        .fr-toolbar h1 {
          color: #222222 !important;
          font-family: Arial, Helvetica, sans-serif !important;
        }
        .fr-toolbar h2 {
          color: #222222 !important;
          font-family: Arial, Helvetica, sans-serif !important;
        }
        .fr-toolbar h3 {
          color: #222222 !important;
          font-family: Arial, Helvetica, sans-serif !important;
        }
        .fr-toolbar h4 {
          color: #222222 !important;
          font-family: Arial, Helvetica, sans-serif !important;
        }
        .fr-toolbar h5 {
          color: #222222 !important;
          font-family: Arial, Helvetica, sans-serif !important;
        }
        .fr-toolbar h6 {
          color: #222222 !important;
          font-family: Arial, Helvetica, sans-serif !important;
        }

        button.btn, a.btn {
          word-break: break-word;
          white-space: break-spaces;
          width: fit-content;
        }
        .fr-command.fr-btn:hover {
          background: none !important;
          border-color: transparent !important;
        }
        section, header, footer {
          margin-right: auto;
          margin-left: auto;
        }
        `;
        this.froala.iframeDoc.head.appendChild(css);
    }

    extendFroalaToolbar() {
      var that = this;
      if ((1===1 || !this.toolbarExtended) && this.froala && this.froala.iframeDoc && this.froala.iframeDoc.defaultView && this.froala.iframeDoc.defaultView.FroalaEditor) {
        if (this.variables) {
          this.froala.iframeDoc.defaultView.FroalaEditor.DefineIcon('variables', {NAME: 'users', template: 'font_awesome'});
          this.froala.iframeDoc.defaultView.FroalaEditor.RegisterCommand('variables', {
            title: 'Variables',
            icon: 'variables',
            focus: false,
            undo: false,
            callback: function (cmd) {
              this.selection.save();
              that.requestVariablePicker('text', this);
            }
          });
          this.createLinkVariableButtons();
        }
        if (this.froala.editor) {
          this.froala.editor.onImageVariablePickerRequested = () => {
            this.requestVariablePicker('image', null);
          };
        }
        this.overrideDefault()
        this.toolbarExtended = true;
      }
    }

    createLinkVariableButtons() {
      var that = this;
      this.froala.iframeDoc.defaultView.FroalaEditor.RegisterCommand('linkUrlVariables', {
        title: 'URL Variables',
        icon: 'variables',
        focus: false,
        undo: false,
        refreshAfterCallback: false,
        callback: function (cmd) {
          that.requestVariablePicker('linkUrl', this);
        },
        plugin: "link"
      });
      this.froala.iframeDoc.defaultView.FroalaEditor.RegisterCommand('linkTextVariables', {
        title: 'Text Variables',
        icon: 'moreText',
        focus: false,
        undo: false,
        refreshAfterCallback: false,
        callback: function (cmd) {
          that.requestVariablePicker('linkText', this);
        },
        plugin: "link"
      });
    }

    // Override Default Commands to add custom functinality
    overrideDefault() {
      var that = this;

      // Override fontFamily Command to add google fonts to list.

      var __googleFonts = {
        // This list was last updated on July 10, 2020
        "ABeeZee": {
          "category": "sans-serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "Abel": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Abhaya Libre": {
          "category": "serif",
          "variants": "400,500,600,700,800",
          "subsets": "latin,latin-ext,sinhala"
        },
        "Abril Fatface": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Aclonica": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Acme": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Actor": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Adamina": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Advent Pro": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700",
          "subsets": "greek,latin,latin-ext"
        },
        "Aguafina Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Akronim": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Aladin": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Alata": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Alatsi": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Aldrich": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Alef": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "hebrew,latin"
        },
        "Alegreya": {
          "category": "serif",
          "variants": "400,400i,500,500i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Alegreya SC": {
          "category": "serif",
          "variants": "400,400i,500,500i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Alegreya Sans": {
          "category": "sans-serif",
          "variants": "100,100i,300,300i,400,400i,500,500i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Alegreya Sans SC": {
          "category": "sans-serif",
          "variants": "100,100i,300,300i,400,400i,500,500i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Aleo": {
          "category": "serif",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Alex Brush": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Alfa Slab One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Alice": {
          "category": "serif",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin"
        },
        "Alike": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Alike Angular": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Allan": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Allerta": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Allerta Stencil": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Allura": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Almarai": {
          "category": "sans-serif",
          "variants": "300,400,700,800",
          "subsets": "arabic"
        },
        "Almendra": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Almendra Display": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Almendra SC": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Amarante": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Amaranth": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "Amatic SC": {
          "category": "handwriting",
          "variants": "400,700",
          "subsets": "cyrillic,hebrew,latin,latin-ext,vietnamese"
        },
        "Amethysta": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Amiko": {
          "category": "sans-serif",
          "variants": "400,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Amiri": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "arabic,latin,latin-ext"
        },
        "Amita": {
          "category": "handwriting",
          "variants": "400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Anaheim": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Andada": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Andika": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Angkor": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Annie Use Your Telescope": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Anonymous Pro": {
          "category": "monospace",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,greek,latin,latin-ext"
        },
        "Antic": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Antic Didone": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Antic Slab": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Anton": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Arapey": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "Arbutus": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Arbutus Slab": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Architects Daughter": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Archivo": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Archivo Black": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Archivo Narrow": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Aref Ruqaa": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "arabic,latin"
        },
        "Arima Madurai": {
          "category": "display",
          "variants": "100,200,300,400,500,700,800,900",
          "subsets": "latin,latin-ext,tamil,vietnamese"
        },
        "Arimo": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,latin,latin-ext,vietnamese"
        },
        "Arizonia": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Armata": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Arsenal": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Artifika": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Arvo": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "Arya": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Asap": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Asap Condensed": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Asar": {
          "category": "serif",
          "variants": "400",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Asset": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Assistant": {
          "category": "sans-serif",
          "variants": "200,300,400,600,700,800",
          "subsets": "hebrew,latin"
        },
        "Astloch": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Asul": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Athiti": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Atma": {
          "category": "display",
          "variants": "300,400,500,600,700",
          "subsets": "bengali,latin,latin-ext"
        },
        "Atomic Age": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Aubrey": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Audiowide": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Autour One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Average": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Average Sans": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Averia Gruesa Libre": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Averia Libre": {
          "category": "display",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "latin"
        },
        "Averia Sans Libre": {
          "category": "display",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "latin"
        },
        "Averia Serif Libre": {
          "category": "display",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "latin"
        },
        "B612": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "B612 Mono": {
          "category": "monospace",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "Bad Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "cyrillic,latin"
        },
        "Bahiana": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Bahianita": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Bai Jamjuree": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Baloo 2": {
          "category": "display",
          "variants": "400,500,600,700,800",
          "subsets": "devanagari,latin,latin-ext,vietnamese"
        },
        "Baloo Bhai 2": {
          "category": "display",
          "variants": "400,500,600,700,800",
          "subsets": "gujarati,latin,latin-ext,vietnamese"
        },
        "Baloo Bhaina 2": {
          "category": "display",
          "variants": "400,500,600,700,800",
          "subsets": "latin,latin-ext,oriya,vietnamese"
        },
        "Baloo Chettan 2": {
          "category": "display",
          "variants": "400,500,600,700,800",
          "subsets": "latin,latin-ext,malayalam,vietnamese"
        },
        "Baloo Da 2": {
          "category": "display",
          "variants": "400,500,600,700,800",
          "subsets": "bengali,latin,latin-ext,vietnamese"
        },
        "Baloo Paaji 2": {
          "category": "display",
          "variants": "400,500,600,700,800",
          "subsets": "gurmukhi,latin,latin-ext,vietnamese"
        },
        "Baloo Tamma 2": {
          "category": "display",
          "variants": "400,500,600,700,800",
          "subsets": "kannada,latin,latin-ext,vietnamese"
        },
        "Baloo Tammudu 2": {
          "category": "display",
          "variants": "400,500,600,700,800",
          "subsets": "latin,latin-ext,telugu,vietnamese"
        },
        "Baloo Thambi 2": {
          "category": "display",
          "variants": "400,500,600,700,800",
          "subsets": "latin,latin-ext,tamil,vietnamese"
        },
        "Balsamiq Sans": {
          "category": "display",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "Balthazar": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Bangers": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Barlow": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Barlow Condensed": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Barlow Semi Condensed": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Barriecito": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Barrio": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Basic": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Baskervville": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Battambang": {
          "category": "display",
          "variants": "400,700",
          "subsets": "khmer"
        },
        "Baumans": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Bayon": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Be Vietnam": {
          "category": "sans-serif",
          "variants": "100,100i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Bebas Neue": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Belgrano": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Bellefair": {
          "category": "serif",
          "variants": "400",
          "subsets": "hebrew,latin,latin-ext"
        },
        "Belleza": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Bellota": {
          "category": "display",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "cyrillic,latin,latin-ext,vietnamese"
        },
        "Bellota Text": {
          "category": "display",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "cyrillic,latin,latin-ext,vietnamese"
        },
        "BenchNine": {
          "category": "sans-serif",
          "variants": "300,400,700",
          "subsets": "latin,latin-ext"
        },
        "Bentham": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Berkshire Swash": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Beth Ellen": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Bevan": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Big Shoulders Display": {
          "category": "display",
          "variants": "100,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Big Shoulders Text": {
          "category": "display",
          "variants": "100,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Bigelow Rules": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Bigshot One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Bilbo": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Bilbo Swash Caps": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "BioRhyme": {
          "category": "serif",
          "variants": "200,300,400,700,800",
          "subsets": "latin,latin-ext"
        },
        "BioRhyme Expanded": {
          "category": "serif",
          "variants": "200,300,400,700,800",
          "subsets": "latin,latin-ext"
        },
        "Biryani": {
          "category": "sans-serif",
          "variants": "200,300,400,600,700,800,900",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Bitter": {
          "category": "serif",
          "variants": "400,400i,700",
          "subsets": "latin,latin-ext"
        },
        "Black And White Picture": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Black Han Sans": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Black Ops One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Blinker": {
          "category": "sans-serif",
          "variants": "100,200,300,400,600,700,800,900",
          "subsets": "latin,latin-ext"
        },
        "Bokor": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Bonbon": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Boogaloo": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Bowlby One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Bowlby One SC": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Brawler": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Bree Serif": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Bubblegum Sans": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Bubbler One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Buda": {
          "category": "display",
          "variants": "300",
          "subsets": "latin"
        },
        "Buenard": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Bungee": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Bungee Hairline": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Bungee Inline": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Bungee Outline": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Bungee Shade": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Butcherman": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Butterfly Kids": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Cabin": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Cabin Condensed": {
          "category": "sans-serif",
          "variants": "400,500,600,700",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Cabin Sketch": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Caesar Dressing": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Cagliostro": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Cairo": {
          "category": "sans-serif",
          "variants": "200,300,400,600,700,900",
          "subsets": "arabic,latin,latin-ext"
        },
        "Caladea": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Calistoga": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Calligraffitti": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Cambay": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Cambo": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Candal": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Cantarell": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "Cantata One": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Cantora One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Capriola": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Cardo": {
          "category": "serif",
          "variants": "400,400i,700",
          "subsets": "greek,greek-ext,latin,latin-ext"
        },
        "Carme": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Carrois Gothic": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Carrois Gothic SC": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Carter One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Catamaran": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,tamil"
        },
        "Caudex": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "greek,greek-ext,latin,latin-ext"
        },
        "Caveat": {
          "category": "handwriting",
          "variants": "400,700",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "Caveat Brush": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Cedarville Cursive": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Ceviche One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Chakra Petch": {
          "category": "sans-serif",
          "variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Changa": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700,800",
          "subsets": "arabic,latin,latin-ext"
        },
        "Changa One": {
          "category": "display",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "Chango": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Charm": {
          "category": "handwriting",
          "variants": "400,700",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Charmonman": {
          "category": "handwriting",
          "variants": "400,700",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Chathura": {
          "category": "sans-serif",
          "variants": "100,300,400,700,800",
          "subsets": "latin,telugu"
        },
        "Chau Philomene One": {
          "category": "sans-serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Chela One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Chelsea Market": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Chenla": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Cherry Cream Soda": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Cherry Swash": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Chewy": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Chicle": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Chilanka": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,malayalam"
        },
        "Chivo": {
          "category": "sans-serif",
          "variants": "300,300i,400,400i,700,700i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "Chonburi": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Cinzel": {
          "category": "serif",
          "variants": "400,700,900",
          "subsets": "latin,latin-ext"
        },
        "Cinzel Decorative": {
          "category": "display",
          "variants": "400,700,900",
          "subsets": "latin"
        },
        "Clicker Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Coda": {
          "category": "display",
          "variants": "400,800",
          "subsets": "latin,latin-ext"
        },
        "Coda Caption": {
          "category": "sans-serif",
          "variants": "800",
          "subsets": "latin,latin-ext"
        },
        "Codystar": {
          "category": "display",
          "variants": "300,400",
          "subsets": "latin,latin-ext"
        },
        "Coiny": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,tamil,vietnamese"
        },
        "Combo": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Comfortaa": {
          "category": "display",
          "variants": "300,400,500,600,700",
          "subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
        },
        "Comic Neue": {
          "category": "handwriting",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "latin"
        },
        "Coming Soon": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Concert One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Condiment": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Content": {
          "category": "display",
          "variants": "400,700",
          "subsets": "khmer"
        },
        "Contrail One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Convergence": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Cookie": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Copse": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Corben": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Cormorant": {
          "category": "serif",
          "variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Cormorant Garamond": {
          "category": "serif",
          "variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Cormorant Infant": {
          "category": "serif",
          "variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Cormorant SC": {
          "category": "serif",
          "variants": "300,400,500,600,700",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Cormorant Unicase": {
          "category": "serif",
          "variants": "300,400,500,600,700",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Cormorant Upright": {
          "category": "serif",
          "variants": "300,400,500,600,700",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Courgette": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Courier Prime": {
          "category": "monospace",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Cousine": {
          "category": "monospace",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,latin,latin-ext,vietnamese"
        },
        "Coustard": {
          "category": "serif",
          "variants": "400,900",
          "subsets": "latin"
        },
        "Covered By Your Grace": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Crafty Girls": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Creepster": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Crete Round": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Crimson Pro": {
          "category": "serif",
          "variants": "200,300,400,500,600,700,800,900,200i,300i,400i,500i,600i,700i,800i,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Crimson Text": {
          "category": "serif",
          "variants": "400,400i,600,600i,700,700i",
          "subsets": "latin"
        },
        "Croissant One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Crushed": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Cuprum": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Cute Font": {
          "category": "display",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Cutive": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Cutive Mono": {
          "category": "monospace",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "DM Mono": {
          "category": "monospace",
          "variants": "300,300i,400,400i,500,500i",
          "subsets": "latin,latin-ext"
        },
        "DM Sans": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "DM Serif Display": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "DM Serif Text": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Damion": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Dancing Script": {
          "category": "handwriting",
          "variants": "400,500,600,700",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Dangrek": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Darker Grotesque": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "David Libre": {
          "category": "serif",
          "variants": "400,500,700",
          "subsets": "hebrew,latin,latin-ext,vietnamese"
        },
        "Dawning of a New Day": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Days One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Dekko": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Delius": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Delius Swash Caps": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Delius Unicase": {
          "category": "handwriting",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Della Respira": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Denk One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Devonshire": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Dhurjati": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Didact Gothic": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
        },
        "Diplomata": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Diplomata SC": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Do Hyeon": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Dokdo": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Domine": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Donegal One": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Doppio One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Dorsa": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Dosis": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700,800",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Dr Sugiyama": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Duru Sans": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Dynalight": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "EB Garamond": {
          "category": "serif",
          "variants": "400,500,600,700,800,400i,500i,600i,700i,800i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Eagle Lake": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "East Sea Dokdo": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Eater": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Economica": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Eczar": {
          "category": "serif",
          "variants": "400,500,600,700,800",
          "subsets": "devanagari,latin,latin-ext"
        },
        "El Messiri": {
          "category": "sans-serif",
          "variants": "400,500,600,700",
          "subsets": "arabic,cyrillic,latin"
        },
        "Electrolize": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Elsie": {
          "category": "display",
          "variants": "400,900",
          "subsets": "latin,latin-ext"
        },
        "Elsie Swash Caps": {
          "category": "display",
          "variants": "400,900",
          "subsets": "latin,latin-ext"
        },
        "Emblema One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Emilys Candy": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Encode Sans": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Encode Sans Condensed": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Encode Sans Expanded": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Encode Sans Semi Condensed": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Encode Sans Semi Expanded": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Engagement": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Englebert": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Enriqueta": {
          "category": "serif",
          "variants": "400,500,600,700",
          "subsets": "latin,latin-ext"
        },
        "Erica One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Esteban": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Euphoria Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Ewert": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Exo": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Exo 2": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Expletus Sans": {
          "category": "display",
          "variants": "400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin"
        },
        "Fahkwang": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Fanwood Text": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "Farro": {
          "category": "sans-serif",
          "variants": "300,400,500,700",
          "subsets": "latin,latin-ext"
        },
        "Farsan": {
          "category": "display",
          "variants": "400",
          "subsets": "gujarati,latin,latin-ext,vietnamese"
        },
        "Fascinate": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Fascinate Inline": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Faster One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Fasthand": {
          "category": "serif",
          "variants": "400",
          "subsets": "khmer"
        },
        "Fauna One": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Faustina": {
          "category": "serif",
          "variants": "400,500,600,700,400i,500i,600i,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Federant": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Federo": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Felipa": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Fenix": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Finger Paint": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Fira Code": {
          "category": "monospace",
          "variants": "300,400,500,600,700",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
        },
        "Fira Mono": {
          "category": "monospace",
          "variants": "400,500,700",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
        },
        "Fira Sans": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Fira Sans Condensed": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Fira Sans Extra Condensed": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Fjalla One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Fjord One": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Flamenco": {
          "category": "display",
          "variants": "300,400",
          "subsets": "latin"
        },
        "Flavors": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Fondamento": {
          "category": "handwriting",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Fontdiner Swanky": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Forum": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "Francois One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Frank Ruhl Libre": {
          "category": "serif",
          "variants": "300,400,500,700,900",
          "subsets": "hebrew,latin,latin-ext"
        },
        "Freckle Face": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Fredericka the Great": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Fredoka One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Freehand": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Fresca": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Frijole": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Fruktur": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Fugaz One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "GFS Didot": {
          "category": "serif",
          "variants": "400",
          "subsets": "greek"
        },
        "GFS Neohellenic": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "greek"
        },
        "Gabriela": {
          "category": "serif",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin"
        },
        "Gaegu": {
          "category": "handwriting",
          "variants": "300,400,700",
          "subsets": "korean,latin"
        },
        "Gafata": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Galada": {
          "category": "display",
          "variants": "400",
          "subsets": "bengali,latin"
        },
        "Galdeano": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Galindo": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Gamja Flower": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Gayathri": {
          "category": "sans-serif",
          "variants": "100,400,700",
          "subsets": "latin,malayalam"
        },
        "Gelasio": {
          "category": "serif",
          "variants": "400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Gentium Basic": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Gentium Book Basic": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Geo": {
          "category": "sans-serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "Geostar": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Geostar Fill": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Germania One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Gidugu": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Gilda Display": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Girassol": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Give You Glory": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Glass Antiqua": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Glegoo": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Gloria Hallelujah": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Goblin One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Gochi Hand": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Gorditas": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Gothic A1": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "korean,latin"
        },
        "Gotu": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "devanagari,latin,latin-ext,vietnamese"
        },
        "Goudy Bookletter 1911": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Graduate": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Grand Hotel": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Gravitas One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Great Vibes": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Grenze": {
          "category": "serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Grenze Gotisch": {
          "category": "display",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Griffy": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Gruppo": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Gudea": {
          "category": "sans-serif",
          "variants": "400,400i,700",
          "subsets": "latin,latin-ext"
        },
        "Gugi": {
          "category": "display",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Gupter": {
          "category": "serif",
          "variants": "400,500,700",
          "subsets": "latin"
        },
        "Gurajada": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Habibi": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Halant": {
          "category": "serif",
          "variants": "300,400,500,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Hammersmith One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Hanalei": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Hanalei Fill": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Handlee": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Hanuman": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "khmer"
        },
        "Happy Monkey": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Harmattan": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "arabic,latin"
        },
        "Headland One": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Heebo": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "hebrew,latin"
        },
        "Henny Penny": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Hepta Slab": {
          "category": "serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Herr Von Muellerhoff": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Hi Melody": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Hind": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Hind Guntur": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "latin,latin-ext,telugu"
        },
        "Hind Madurai": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "latin,latin-ext,tamil"
        },
        "Hind Siliguri": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "bengali,latin,latin-ext"
        },
        "Hind Vadodara": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "gujarati,latin,latin-ext"
        },
        "Holtwood One SC": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Homemade Apple": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Homenaje": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "IBM Plex Mono": {
          "category": "monospace",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "IBM Plex Sans": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
        },
        "IBM Plex Sans Condensed": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "IBM Plex Serif": {
          "category": "serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "IM Fell DW Pica": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "IM Fell DW Pica SC": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "IM Fell Double Pica": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "IM Fell Double Pica SC": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "IM Fell English": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "IM Fell English SC": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "IM Fell French Canon": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "IM Fell French Canon SC": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "IM Fell Great Primer": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "IM Fell Great Primer SC": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Ibarra Real Nova": {
          "category": "serif",
          "variants": "400,400i,600,600i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Iceberg": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Iceland": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Imprima": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Inconsolata": {
          "category": "monospace",
          "variants": "200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Inder": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Indie Flower": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Inika": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Inknut Antiqua": {
          "category": "serif",
          "variants": "300,400,500,600,700,800,900",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Inria Sans": {
          "category": "sans-serif",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Inria Serif": {
          "category": "serif",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Inter": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Irish Grover": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Istok Web": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "Italiana": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Italianno": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Itim": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Jacques Francois": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Jacques Francois Shadow": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Jaldi": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Jim Nightshade": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Jockey One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Jolly Lodger": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Jomhuria": {
          "category": "display",
          "variants": "400",
          "subsets": "arabic,latin,latin-ext"
        },
        "Jomolhari": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,tibetan"
        },
        "Josefin Sans": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,100i,200i,300i,400i,500i,600i,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Josefin Slab": {
          "category": "serif",
          "variants": "100,100i,300,300i,400,400i,600,600i,700,700i",
          "subsets": "latin"
        },
        "Jost": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Joti One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Jua": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Judson": {
          "category": "serif",
          "variants": "400,400i,700",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Julee": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Julius Sans One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Junge": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Jura": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Just Another Hand": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Just Me Again Down Here": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "K2D": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Kadwa": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "devanagari,latin"
        },
        "Kalam": {
          "category": "handwriting",
          "variants": "300,400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Kameron": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Kanit": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Kantumruy": {
          "category": "sans-serif",
          "variants": "300,400,700",
          "subsets": "khmer"
        },
        "Karla": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Karma": {
          "category": "serif",
          "variants": "300,400,500,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Katibeh": {
          "category": "display",
          "variants": "400",
          "subsets": "arabic,latin,latin-ext"
        },
        "Kaushan Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Kavivanar": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext,tamil"
        },
        "Kavoon": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Kdam Thmor": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Keania One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Kelly Slab": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Kenia": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Khand": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Khmer": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Khula": {
          "category": "sans-serif",
          "variants": "300,400,600,700,800",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Kirang Haerang": {
          "category": "display",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Kite One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Knewave": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "KoHo": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Kodchasan": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Kosugi": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,japanese,latin"
        },
        "Kosugi Maru": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,japanese,latin"
        },
        "Kotta One": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Koulen": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Kranky": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Kreon": {
          "category": "serif",
          "variants": "300,400,500,600,700",
          "subsets": "latin,latin-ext"
        },
        "Kristi": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Krona One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Krub": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Kulim Park": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,600,600i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Kumar One": {
          "category": "display",
          "variants": "400",
          "subsets": "gujarati,latin,latin-ext"
        },
        "Kumar One Outline": {
          "category": "display",
          "variants": "400",
          "subsets": "gujarati,latin,latin-ext"
        },
        "Kurale": {
          "category": "serif",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,devanagari,latin,latin-ext"
        },
        "La Belle Aurore": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Lacquer": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Laila": {
          "category": "serif",
          "variants": "300,400,500,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Lakki Reddy": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Lalezar": {
          "category": "display",
          "variants": "400",
          "subsets": "arabic,latin,latin-ext,vietnamese"
        },
        "Lancelot": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Lateef": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "arabic,latin"
        },
        "Lato": {
          "category": "sans-serif",
          "variants": "100,100i,300,300i,400,400i,700,700i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "League Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Leckerli One": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Ledger": {
          "category": "serif",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Lekton": {
          "category": "sans-serif",
          "variants": "400,400i,700",
          "subsets": "latin,latin-ext"
        },
        "Lemon": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Lemonada": {
          "category": "display",
          "variants": "300,400,500,600,700",
          "subsets": "arabic,latin,latin-ext,vietnamese"
        },
        "Lexend Deca": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Lexend Exa": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Lexend Giga": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Lexend Mega": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Lexend Peta": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Lexend Tera": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Lexend Zetta": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Libre Barcode 128": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Libre Barcode 128 Text": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Libre Barcode 39": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Libre Barcode 39 Extended": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Libre Barcode 39 Extended Text": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Libre Barcode 39 Text": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Libre Baskerville": {
          "category": "serif",
          "variants": "400,400i,700",
          "subsets": "latin,latin-ext"
        },
        "Libre Caslon Display": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Libre Caslon Text": {
          "category": "serif",
          "variants": "400,400i,700",
          "subsets": "latin,latin-ext"
        },
        "Libre Franklin": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "Life Savers": {
          "category": "display",
          "variants": "400,700,800",
          "subsets": "latin,latin-ext"
        },
        "Lilita One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Lily Script One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Limelight": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Linden Hill": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "Literata": {
          "category": "serif",
          "variants": "400,500,600,700,400i,500i,600i,700i",
          "subsets": "cyrillic,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Liu Jian Mao Cao": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "chinese-simplified,latin"
        },
        "Livvic": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,900,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Lobster": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Lobster Two": {
          "category": "display",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "Londrina Outline": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Londrina Shadow": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Londrina Sketch": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Londrina Solid": {
          "category": "display",
          "variants": "100,300,400,900",
          "subsets": "latin"
        },
        "Long Cang": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "chinese-simplified,latin"
        },
        "Lora": {
          "category": "serif",
          "variants": "400,500,600,700,400i,500i,600i,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Love Ya Like A Sister": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Loved by the King": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Lovers Quarrel": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Luckiest Guy": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Lusitana": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Lustria": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "M PLUS 1p": {
          "category": "sans-serif",
          "variants": "100,300,400,500,700,800,900",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,japanese,latin,latin-ext,vietnamese"
        },
        "M PLUS Rounded 1c": {
          "category": "sans-serif",
          "variants": "100,300,400,500,700,800,900",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,japanese,latin,latin-ext,vietnamese"
        },
        "Ma Shan Zheng": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "chinese-simplified,latin"
        },
        "Macondo": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Macondo Swash Caps": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Mada": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700,900",
          "subsets": "arabic,latin"
        },
        "Magra": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Maiden Orange": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Maitree": {
          "category": "serif",
          "variants": "200,300,400,500,600,700",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Major Mono Display": {
          "category": "monospace",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Mako": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Mali": {
          "category": "handwriting",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Mallanna": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Mandali": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Manjari": {
          "category": "sans-serif",
          "variants": "100,400,700",
          "subsets": "latin,malayalam"
        },
        "Manrope": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700,800",
          "subsets": "cyrillic,greek,latin,latin-ext"
        },
        "Mansalva": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Manuale": {
          "category": "serif",
          "variants": "400,500,600,700,400i,500i,600i,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Marcellus": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Marcellus SC": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Marck Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Margarine": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Markazi Text": {
          "category": "serif",
          "variants": "400,500,600,700",
          "subsets": "arabic,latin,latin-ext,vietnamese"
        },
        "Marko One": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Marmelad": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Martel": {
          "category": "serif",
          "variants": "200,300,400,600,700,800,900",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Martel Sans": {
          "category": "sans-serif",
          "variants": "200,300,400,600,700,800,900",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Marvel": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "Mate": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "Mate SC": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Maven Pro": {
          "category": "sans-serif",
          "variants": "400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "McLaren": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Meddon": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "MedievalSharp": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Medula One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Meera Inimai": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,tamil"
        },
        "Megrim": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Meie Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Merienda": {
          "category": "handwriting",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Merienda One": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Merriweather": {
          "category": "serif",
          "variants": "300,300i,400,400i,700,700i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Merriweather Sans": {
          "category": "sans-serif",
          "variants": "300,300i,400,400i,700,700i,800,800i",
          "subsets": "latin,latin-ext"
        },
        "Metal": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Metal Mania": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Metamorphous": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Metrophobic": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Michroma": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Milonga": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Miltonian": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Miltonian Tattoo": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Mina": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "bengali,latin,latin-ext"
        },
        "Miniver": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Miriam Libre": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "hebrew,latin,latin-ext"
        },
        "Mirza": {
          "category": "display",
          "variants": "400,500,600,700",
          "subsets": "arabic,latin,latin-ext"
        },
        "Miss Fajardose": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Mitr": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Modak": {
          "category": "display",
          "variants": "400",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Modern Antiqua": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Mogra": {
          "category": "display",
          "variants": "400",
          "subsets": "gujarati,latin,latin-ext"
        },
        "Molengo": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Molle": {
          "category": "handwriting",
          "variants": "400i",
          "subsets": "latin,latin-ext"
        },
        "Monda": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Monofett": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Monoton": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Monsieur La Doulaise": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Montaga": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Montez": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Montserrat": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Montserrat Alternates": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Montserrat Subrayada": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Moul": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Moulpali": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Mountains of Christmas": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Mouse Memoirs": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Mr Bedfort": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Mr Dafoe": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Mr De Haviland": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Mrs Saint Delafield": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Mrs Sheppards": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Mukta": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700,800",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Mukta Mahee": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700,800",
          "subsets": "gurmukhi,latin,latin-ext"
        },
        "Mukta Malar": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700,800",
          "subsets": "latin,latin-ext,tamil"
        },
        "Mukta Vaani": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700,800",
          "subsets": "gujarati,latin,latin-ext"
        },
        "Muli": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700,800,900,200i,300i,400i,500i,600i,700i,800i,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "MuseoModerno": {
          "category": "display",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Mystery Quest": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "NTR": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Nanum Brush Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Nanum Gothic": {
          "category": "sans-serif",
          "variants": "400,700,800",
          "subsets": "korean,latin"
        },
        "Nanum Gothic Coding": {
          "category": "monospace",
          "variants": "400,700",
          "subsets": "korean,latin"
        },
        "Nanum Myeongjo": {
          "category": "serif",
          "variants": "400,700,800",
          "subsets": "korean,latin"
        },
        "Nanum Pen Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Neucha": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "cyrillic,latin"
        },
        "Neuton": {
          "category": "serif",
          "variants": "200,300,400,400i,700,800",
          "subsets": "latin,latin-ext"
        },
        "New Rocker": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "News Cycle": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Niconne": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Niramit": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Nixie One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Nobile": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Nokora": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "khmer"
        },
        "Norican": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Nosifer": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Notable": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Nothing You Could Do": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Noticia Text": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Noto Sans": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,devanagari,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Noto Sans HK": {
          "category": "sans-serif",
          "variants": "100,300,400,500,700,900",
          "subsets": "chinese-hongkong,latin"
        },
        "Noto Sans JP": {
          "category": "sans-serif",
          "variants": "100,300,400,500,700,900",
          "subsets": "japanese,latin"
        },
        "Noto Sans KR": {
          "category": "sans-serif",
          "variants": "100,300,400,500,700,900",
          "subsets": "korean,latin"
        },
        "Noto Sans SC": {
          "category": "sans-serif",
          "variants": "100,300,400,500,700,900",
          "subsets": "chinese-simplified,latin"
        },
        "Noto Sans TC": {
          "category": "sans-serif",
          "variants": "100,300,400,500,700,900",
          "subsets": "chinese-traditional,latin"
        },
        "Noto Serif": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Noto Serif JP": {
          "category": "serif",
          "variants": "200,300,400,500,600,700,900",
          "subsets": "japanese,latin"
        },
        "Noto Serif KR": {
          "category": "serif",
          "variants": "200,300,400,500,600,700,900",
          "subsets": "korean,latin"
        },
        "Noto Serif SC": {
          "category": "serif",
          "variants": "200,300,400,500,600,700,900",
          "subsets": "chinese-simplified,latin"
        },
        "Noto Serif TC": {
          "category": "serif",
          "variants": "200,300,400,500,600,700,900",
          "subsets": "chinese-traditional,latin"
        },
        "Nova Cut": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Nova Flat": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Nova Mono": {
          "category": "monospace",
          "variants": "400",
          "subsets": "greek,latin"
        },
        "Nova Oval": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Nova Round": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Nova Script": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Nova Slim": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Nova Square": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Numans": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Nunito": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Nunito Sans": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Odibee Sans": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Odor Mean Chey": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Offside": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Old Standard TT": {
          "category": "serif",
          "variants": "400,400i,700",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Oldenburg": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Oleo Script": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Oleo Script Swash Caps": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Open Sans": {
          "category": "sans-serif",
          "variants": "300,300i,400,400i,600,600i,700,700i,800,800i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Open Sans Condensed": {
          "category": "sans-serif",
          "variants": "300,300i,700",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Oranienbaum": {
          "category": "serif",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "Orbitron": {
          "category": "sans-serif",
          "variants": "400,500,600,700,800,900",
          "subsets": "latin"
        },
        "Oregano": {
          "category": "display",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Orienta": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Original Surfer": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Oswald": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Over the Rainbow": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Overlock": {
          "category": "display",
          "variants": "400,400i,700,700i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "Overlock SC": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Overpass": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "Overpass Mono": {
          "category": "monospace",
          "variants": "300,400,600,700",
          "subsets": "latin,latin-ext"
        },
        "Ovo": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Oxanium": {
          "category": "display",
          "variants": "200,300,400,500,600,700,800",
          "subsets": "latin,latin-ext"
        },
        "Oxygen": {
          "category": "sans-serif",
          "variants": "300,400,700",
          "subsets": "latin,latin-ext"
        },
        "Oxygen Mono": {
          "category": "monospace",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "PT Mono": {
          "category": "monospace",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "PT Sans": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "PT Sans Caption": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "PT Sans Narrow": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "PT Serif": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "PT Serif Caption": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "Pacifico": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Padauk": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "latin,myanmar"
        },
        "Palanquin": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Palanquin Dark": {
          "category": "sans-serif",
          "variants": "400,500,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Pangolin": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Paprika": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Parisienne": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Passero One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Passion One": {
          "category": "display",
          "variants": "400,700,900",
          "subsets": "latin,latin-ext"
        },
        "Pathway Gothic One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Patrick Hand": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Patrick Hand SC": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Pattaya": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext,thai,vietnamese"
        },
        "Patua One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Pavanam": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,tamil"
        },
        "Paytone One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Peddana": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Peralta": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Permanent Marker": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Petit Formal Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Petrona": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Philosopher": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,vietnamese"
        },
        "Piedra": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Pinyon Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Pirata One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Plaster": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Play": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
        },
        "Playball": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Playfair Display": {
          "category": "serif",
          "variants": "400,500,600,700,800,900,400i,500i,600i,700i,800i,900i",
          "subsets": "cyrillic,latin,latin-ext,vietnamese"
        },
        "Playfair Display SC": {
          "category": "serif",
          "variants": "400,400i,700,700i,900,900i",
          "subsets": "cyrillic,latin,latin-ext,vietnamese"
        },
        "Podkova": {
          "category": "serif",
          "variants": "400,500,600,700,800",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Poiret One": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Poller One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Poly": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin"
        },
        "Pompiere": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Pontano Sans": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Poor Story": {
          "category": "display",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Poppins": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Port Lligat Sans": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Port Lligat Slab": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Pragati Narrow": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Prata": {
          "category": "serif",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,vietnamese"
        },
        "Preahvihear": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Press Start 2P": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext"
        },
        "Pridi": {
          "category": "serif",
          "variants": "200,300,400,500,600,700",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Princess Sofia": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Prociono": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Prompt": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Prosto One": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Proza Libre": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,600,600i,700,700i,800,800i",
          "subsets": "latin,latin-ext"
        },
        "Public Sans": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
          "subsets": "latin,latin-ext"
        },
        "Puritan": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "Purple Purse": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Quando": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Quantico": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "Quattrocento": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Quattrocento Sans": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Questrial": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Quicksand": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Quintessential": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Qwigley": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Racing Sans One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Radley": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Rajdhani": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Rakkas": {
          "category": "display",
          "variants": "400",
          "subsets": "arabic,latin,latin-ext"
        },
        "Raleway": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "Raleway Dots": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Ramabhadra": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Ramaraja": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Rambla": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Rammetto One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Ranchers": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Rancho": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Ranga": {
          "category": "display",
          "variants": "400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Rasa": {
          "category": "serif",
          "variants": "300,400,500,600,700",
          "subsets": "gujarati,latin,latin-ext"
        },
        "Rationale": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Ravi Prakash": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Red Hat Display": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,700,700i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "Red Hat Text": {
          "category": "sans-serif",
          "variants": "400,400i,500,500i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Redressed": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Reem Kufi": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "arabic,latin"
        },
        "Reenie Beanie": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Revalia": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Rhodium Libre": {
          "category": "serif",
          "variants": "400",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Ribeye": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Ribeye Marrow": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Righteous": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Risque": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Roboto": {
          "category": "sans-serif",
          "variants": "100,100i,300,300i,400,400i,500,500i,700,700i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Roboto Condensed": {
          "category": "sans-serif",
          "variants": "300,300i,400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Roboto Mono": {
          "category": "monospace",
          "variants": "100,200,300,400,500,600,700,100i,200i,300i,400i,500i,600i,700i",
          "subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
        },
        "Roboto Slab": {
          "category": "serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Rochester": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Rock Salt": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Rokkitt": {
          "category": "serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Romanesco": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Ropa Sans": {
          "category": "sans-serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Rosario": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700,300i,400i,500i,600i,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Rosarivo": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Rouge Script": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Rozha One": {
          "category": "serif",
          "variants": "400",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Rubik": {
          "category": "sans-serif",
          "variants": "300,300i,400,400i,500,500i,700,700i,900,900i",
          "subsets": "cyrillic,hebrew,latin,latin-ext"
        },
        "Rubik Mono One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Ruda": {
          "category": "sans-serif",
          "variants": "400,500,600,700,800,900",
          "subsets": "cyrillic,latin,latin-ext,vietnamese"
        },
        "Rufina": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Ruge Boogie": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Ruluko": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Rum Raisin": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Ruslan Display": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Russo One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Ruthie": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Rye": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Sacramento": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Sahitya": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "devanagari,latin"
        },
        "Sail": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Saira": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Saira Condensed": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Saira Extra Condensed": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Saira Semi Condensed": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Saira Stencil One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Salsa": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Sanchez": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Sancreek": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Sansita": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "Sarabun": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Sarala": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Sarina": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Sarpanch": {
          "category": "sans-serif",
          "variants": "400,500,600,700,800,900",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Satisfy": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Sawarabi Gothic": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,japanese,latin,latin-ext,vietnamese"
        },
        "Sawarabi Mincho": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "japanese,latin,latin-ext"
        },
        "Scada": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
        },
        "Scheherazade": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "arabic,latin"
        },
        "Schoolbell": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Scope One": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Seaweed Script": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Secular One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "hebrew,latin,latin-ext"
        },
        "Sedgwick Ave": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Sedgwick Ave Display": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Sen": {
          "category": "sans-serif",
          "variants": "400,700,800",
          "subsets": "latin,latin-ext"
        },
        "Sevillana": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Seymour One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Shadows Into Light": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Shadows Into Light Two": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Shanti": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Share": {
          "category": "display",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Share Tech": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Share Tech Mono": {
          "category": "monospace",
          "variants": "400",
          "subsets": "latin"
        },
        "Shojumaru": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Short Stack": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Shrikhand": {
          "category": "display",
          "variants": "400",
          "subsets": "gujarati,latin,latin-ext"
        },
        "Siemreap": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Sigmar One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Signika": {
          "category": "sans-serif",
          "variants": "300,400,600,700",
          "subsets": "latin,latin-ext"
        },
        "Signika Negative": {
          "category": "sans-serif",
          "variants": "300,400,600,700",
          "subsets": "latin,latin-ext"
        },
        "Simonetta": {
          "category": "display",
          "variants": "400,400i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "Single Day": {
          "category": "display",
          "variants": "400",
          "subsets": "korean"
        },
        "Sintony": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Sirin Stencil": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Six Caps": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Skranji": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        },
        "Slabo 13px": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Slabo 27px": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Slackey": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Smokum": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Smythe": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Sniglet": {
          "category": "display",
          "variants": "400,800",
          "subsets": "latin,latin-ext"
        },
        "Snippet": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Snowburst One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Sofadi One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Sofia": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Solway": {
          "category": "serif",
          "variants": "300,400,500,700,800",
          "subsets": "latin"
        },
        "Song Myung": {
          "category": "serif",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Sonsie One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Sorts Mill Goudy": {
          "category": "serif",
          "variants": "400,400i",
          "subsets": "latin,latin-ext"
        },
        "Source Code Pro": {
          "category": "monospace",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
        },
        "Source Sans Pro": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,600,600i,700,700i,900,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
        },
        "Source Serif Pro": {
          "category": "serif",
          "variants": "400,600,700",
          "subsets": "latin,latin-ext"
        },
        "Space Mono": {
          "category": "monospace",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Spartan": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900",
          "subsets": "latin,latin-ext"
        },
        "Special Elite": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Spectral": {
          "category": "serif",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
          "subsets": "cyrillic,latin,latin-ext,vietnamese"
        },
        "Spectral SC": {
          "category": "serif",
          "variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
          "subsets": "cyrillic,latin,latin-ext,vietnamese"
        },
        "Spicy Rice": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Spinnaker": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Spirax": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Squada One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Sree Krushnadevaraya": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Sriracha": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Srisakdi": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Staatliches": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Stalemate": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Stalinist One": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Stardos Stencil": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Stint Ultra Condensed": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Stint Ultra Expanded": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Stoke": {
          "category": "serif",
          "variants": "300,400",
          "subsets": "latin,latin-ext"
        },
        "Strait": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Stylish": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Sue Ellen Francisco": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Suez One": {
          "category": "serif",
          "variants": "400",
          "subsets": "hebrew,latin,latin-ext"
        },
        "Sulphur Point": {
          "category": "sans-serif",
          "variants": "300,400,700",
          "subsets": "latin,latin-ext"
        },
        "Sumana": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Sunflower": {
          "category": "sans-serif",
          "variants": "300,500,700",
          "subsets": "korean,latin"
        },
        "Sunshiney": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Supermercado One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Sura": {
          "category": "serif",
          "variants": "400,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Suranna": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Suravaram": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Suwannaphum": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Swanky and Moo Moo": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Syncopate": {
          "category": "sans-serif",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Tajawal": {
          "category": "sans-serif",
          "variants": "200,300,400,500,700,800,900",
          "subsets": "arabic,latin"
        },
        "Tangerine": {
          "category": "handwriting",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Taprom": {
          "category": "display",
          "variants": "400",
          "subsets": "khmer"
        },
        "Tauri": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Taviraj": {
          "category": "serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Teko": {
          "category": "sans-serif",
          "variants": "300,400,500,600,700",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Telex": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Tenali Ramakrishna": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Tenor Sans": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Text Me One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Thasadith": {
          "category": "sans-serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "The Girl Next Door": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Tienne": {
          "category": "serif",
          "variants": "400,700,900",
          "subsets": "latin"
        },
        "Tillana": {
          "category": "handwriting",
          "variants": "400,500,600,700,800",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Timmana": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,telugu"
        },
        "Tinos": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,latin,latin-ext,vietnamese"
        },
        "Titan One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Titillium Web": {
          "category": "sans-serif",
          "variants": "200,200i,300,300i,400,400i,600,600i,700,700i,900",
          "subsets": "latin,latin-ext"
        },
        "Tomorrow": {
          "category": "sans-serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext"
        },
        "Trade Winds": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Trirong": {
          "category": "serif",
          "variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
          "subsets": "latin,latin-ext,thai,vietnamese"
        },
        "Trocchi": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Trochut": {
          "category": "display",
          "variants": "400,400i,700",
          "subsets": "latin"
        },
        "Trykker": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Tulpen One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Turret Road": {
          "category": "display",
          "variants": "200,300,400,500,700,800",
          "subsets": "latin,latin-ext"
        },
        "Ubuntu": {
          "category": "sans-serif",
          "variants": "300,300i,400,400i,500,500i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
        },
        "Ubuntu Condensed": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
        },
        "Ubuntu Mono": {
          "category": "monospace",
          "variants": "400,400i,700,700i",
          "subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
        },
        "Ultra": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Uncial Antiqua": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Underdog": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,latin,latin-ext"
        },
        "Unica One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "UnifrakturCook": {
          "category": "display",
          "variants": "700",
          "subsets": "latin"
        },
        "UnifrakturMaguntia": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Unkempt": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin"
        },
        "Unlock": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Unna": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "VT323": {
          "category": "monospace",
          "variants": "400",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Vampiro One": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Varela": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Varela Round": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "hebrew,latin,latin-ext,vietnamese"
        },
        "Vast Shadow": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Vesper Libre": {
          "category": "serif",
          "variants": "400,500,700,900",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Viaoda Libre": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Vibes": {
          "category": "display",
          "variants": "400",
          "subsets": "arabic,latin"
        },
        "Vibur": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Vidaloka": {
          "category": "serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Viga": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Voces": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Volkhov": {
          "category": "serif",
          "variants": "400,400i,700,700i",
          "subsets": "latin"
        },
        "Vollkorn": {
          "category": "serif",
          "variants": "400,500,600,700,800,900,400i,500i,600i,700i,800i,900i",
          "subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
        },
        "Vollkorn SC": {
          "category": "serif",
          "variants": "400,600,700,900",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Voltaire": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Waiting for the Sunrise": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Wallpoet": {
          "category": "display",
          "variants": "400",
          "subsets": "latin"
        },
        "Walter Turncoat": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Warnes": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Wellfleet": {
          "category": "display",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Wendy One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin,latin-ext"
        },
        "Wire One": {
          "category": "sans-serif",
          "variants": "400",
          "subsets": "latin"
        },
        "Work Sans": {
          "category": "sans-serif",
          "variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
          "subsets": "latin,latin-ext,vietnamese"
        },
        "Yanone Kaffeesatz": {
          "category": "sans-serif",
          "variants": "200,300,400,500,600,700",
          "subsets": "cyrillic,latin,latin-ext,vietnamese"
        },
        "Yantramanav": {
          "category": "sans-serif",
          "variants": "100,300,400,500,700,900",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Yatra One": {
          "category": "display",
          "variants": "400",
          "subsets": "devanagari,latin,latin-ext"
        },
        "Yellowtail": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Yeon Sung": {
          "category": "display",
          "variants": "400",
          "subsets": "korean,latin"
        },
        "Yeseva One": {
          "category": "display",
          "variants": "400",
          "subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
        },
        "Yesteryear": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Yrsa": {
          "category": "serif",
          "variants": "300,400,500,600,700",
          "subsets": "latin,latin-ext"
        },
        "ZCOOL KuaiLe": {
          "category": "display",
          "variants": "400",
          "subsets": "chinese-simplified,latin"
        },
        "ZCOOL QingKe HuangYou": {
          "category": "display",
          "variants": "400",
          "subsets": "chinese-simplified,latin"
        },
        "ZCOOL XiaoWei": {
          "category": "serif",
          "variants": "400",
          "subsets": "chinese-simplified,latin"
        },
        "Zeyada": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "latin"
        },
        "Zhi Mang Xing": {
          "category": "handwriting",
          "variants": "400",
          "subsets": "chinese-simplified,latin"
        },
        "Zilla Slab": {
          "category": "serif",
          "variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
          "subsets": "latin,latin-ext"
        },
        "Zilla Slab Highlight": {
          "category": "display",
          "variants": "400,700",
          "subsets": "latin,latin-ext"
        }
      };
      Object.assign(this.froala.iframeDoc.defaultView.FroalaEditor.DEFAULTS.fontFamily, {
        ...(Object.keys(__googleFonts).reduce((r, v) => {
          return {...r, [`google-${v}, ${__googleFonts[v].subsets}`]: `${v}`}
        }, {}))
      })

      this.froala.iframeDoc.defaultView.FroalaEditor.RegisterCommand("fontFamily", {
        type: "dropdown",
        displaySelection: function (editor) {
          return editor.opts.fontFamilySelection
        },
        defaultSelection: function (editor) {
          return editor.opts.fontFamilyDefaultSelection
        },
        displaySelectionWidth: 120,
        html: function () {
          var html = '<ul class="fr-dropdown-list" role="presentation">';
          var fontFamilies = this.opts.fontFamily;
          for (var family in fontFamilies) {
            if (fontFamilies.hasOwnProperty(family)) {
              html += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontFamily" data-param1="'.concat(fontFamilies[family], '" \n        style="font-family: ').concat(family.replace('google-', ''), '" title="').concat(fontFamilies[family], '">').concat(fontFamilies[family], "</a></li>")
            }
          }
          return html += "</ul>"
        },
        title: "Font Family",
        callback: function (cmd, font) {
          that.loadGoogleFont(font)
          setTimeout(() => {
            this.fontFamily.apply(font)
          }, 500);
        },
        refresh: function (element) {
          this.fontFamily.refresh(element)
        },
        refreshOnShow: function (element, t) {
          if (t) t[0].style.overflow = 'hidden auto';
          setTimeout(() => {
            t = $(t);
            let selectTop = t.offset().top
            let selectHeight = t.height()
            let inview, optionTop
            let option = t.find('li')
              let beforeFontFamily = '';
              let currentLi = null;
              if (that?.froala?.editor?.FroalaEditor?.SELECTED_TARGET) {
                  try {
                      beforeFontFamily = window.getComputedStyle(that?.froala.editor.FroalaEditor.SELECTED_TARGET, null).getPropertyValue('font-family')
                      if (beforeFontFamily) {
                          beforeFontFamily = beforeFontFamily.split('"').join('');
                          let found = false;
                          option.each(function () {
                              const a = $(this).find('a');
                              const font = $(a).attr("title");
                              $(a).attr('aria-selected', 'false');
                              $(a).removeClass('fr-active');
                              if (font === beforeFontFamily) {
                                  found = true;
                                  $(a).attr('aria-selected', 'true');
                                  $(a).addClass('fr-active');
                              }
                          })

                          if (!found) {
                              const obj = {...this.opts.fontFamily};
                              obj[beforeFontFamily] = beforeFontFamily
                              let sorted = Object.keys(obj);
                              sorted.sort();
                              let html = '';
                              for (const family of sorted) {
                                  if (obj.hasOwnProperty(family)) {
                                      html += '<li role="presentation"><a class="fr-command ' +
                                          (family === beforeFontFamily ? 'fr-active' : '') + '" ' + (family === beforeFontFamily ? 'aria-selected="true"' : '') +
                                          ' tabIndex="-1" role="option" data-cmd="fontFamily" data-param1="'.concat(obj[family], '"style="font-family: ').concat(family.replace('google-', ''), '" title="').concat(obj[family], '">').concat(obj[family], "</a></li>")
                                  }
                              }
                              t.find('ul').html(html);
                          }

                          if (t.find('.fr-active')) {
                              t.animate({
                                  scrollTop: (t.find('.fr-active').parent().index() * t.find('.fr-active').parent().height()) - t.find('.fr-active').parent().height()
                              });
                          }
                      }
                  } catch (e) {
                      console.log('Error in finding current font-family', e);
                  }
              }
            t.on('scroll', function() {
              option.each(function() {
                let _this = $(this)
                optionTop = _this.offset().top
                inview = optionTop >= selectTop && optionTop < selectTop + selectHeight
                if (inview)	{
                  if (_this.attr('data-status') !== 'success' &&
                    _this.attr('data-status') !== 'loading' &&
                    _this.attr('data-status') !== 'error') {
                    _this.attr('data-status', 'loading')
                    let a = _this.find('a');
                    let font = $(a).attr("title");

                    if (font) {
                      that.loadGoogleFont(font)
                    }
                  }
                }
              });
            });
          }, 1000);
          this.fontFamily.refreshOnShow(element, t)

            /** code here */

        },
        plugin: "fontFamily"
      })

        this.froala.iframeDoc.defaultView.FroalaEditor.RegisterCommand("fontSize", {
            type: 'dropdown',
            title: 'Font Size',
            icon: 'fontSize',
            displaySelection: function (e) {
                return e.opts.fontSizeSelection;
            },
            displaySelectionWidth: 30,
            defaultSelection: function (e) {
                return e.opts.fontSizeDefaultSelection;
            },
            html: function () {
                let e = '<ul class="fr-dropdown-list" role="presentation">';
                let t = this.opts.fontSize;
                for (let n = 0; n < t.length; n++) {
                    const r = t[n];
                    e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontSize" data-param1="'.concat(r).concat(this.opts.fontSizeUnit, '" title="').concat(r, '">').concat(r, '</a></li>');
                }
                return e += '</ul>';
            },
            callback: function (e, font_size) {
              setTimeout(() => {
                this.fontSize.apply(font_size)
              }, 500);
            },
            refresh: function (e) {
                this.fontSize.refresh(e);
            },
            refreshOnShow: function (e, t) {
                setTimeout(() => {
                    t = $(t);
                    const option = t.find('li');
                    let beforeFontSize = 0;
                    if (that.froala.editor.FroalaEditor?.SELECTED_TARGET) {
                        try {
                            beforeFontSize = window.getComputedStyle(that.froala.editor.FroalaEditor.SELECTED_TARGET, null).getPropertyValue('font-size');
                            if (beforeFontSize) {
                                beforeFontSize = parseInt(beforeFontSize);
                                let counter = -1;
                                let found = false;
                                option.each(function () {
                                    counter++;
                                    const a = $(this).find('a');
                                    $(a).attr('aria-selected', 'false');
                                    $(a).removeClass('fr-active');
                                    const font = parseInt($(a).attr('title'));
                                    if (font === beforeFontSize) {
                                        found = true;
                                        $(a).attr('aria-selected', 'true');
                                        $(a).addClass('fr-active');
                                    }
                                });
                                if (!found) {
                                    let arr = [...this.opts.fontSize];
                                    let html = '';
                                    arr.push(beforeFontSize.toString());
                                    arr.sort((a, b) => a - b);
                                    for (let n = 0; n < arr.length; n++) {
                                        const r = arr[n];
                                        html += '<li role="presentation"><a class="fr-command' + (r == beforeFontSize ? ' fr-active' : '')
                                            + '" ' + (r == beforeFontSize ? 'aria-selected="true" ' : '')
                                            + ' tabIndex="-1" role="option" data-cmd="fontSize" data-param1="'.concat(r).concat(this.opts.fontSizeUnit, '" title="').concat(r, '">').concat(r, '</a></li>');
                                    }
                                    t.find('ul').html(html);
                                }
                                if (t.find('.fr-active')) {
                                    t.animate({
                                        scrollTop: (t.find('.fr-active').parent().index() * t.find('.fr-active').parent().height()) - t.find('.fr-active').parent().height()
                                    });
                                }
                            }
                        } catch (e) {
                            console.log('Error in finding current font-size', e);
                        }
                    }
                }, 500);
                this.fontSize.refreshOnShow(e, t);
            },
            plugin: 'fontSize'
        });

      // Override paragraphFormat Command to fix not formatting code.
      this.froala.iframeDoc.defaultView.FroalaEditor.RegisterCommand("paragraphFormat", {
        type: "dropdown",
        displaySelection: function (e) {
          return e.opts.paragraphFormatSelection
        },
        defaultSelection: function (e) {
          return e.language.translate(e.opts.paragraphDefaultSelection)
        },
        displaySelectionWidth: 80,
        html: function () {
          var html = '<ul class="fr-dropdown-list" role="presentation">';
          var paragraphFormat = this.opts.paragraphFormat;
          delete paragraphFormat['PRE'];
          for (var format in paragraphFormat) {
            if (paragraphFormat.hasOwnProperty(format)) {
              var checkFormatShortcut = this.shortcuts.get("paragraphFormat." + format);
              checkFormatShortcut = checkFormatShortcut && '<span class="fr-shortcut">' + checkFormatShortcut + '</span>'
              html += '<li role="presentation"><' + ("N" == format ? this.html.defaultTag() || "DIV" : format) + ' style="padding: 0 !important; margin: 0 !important; border: 0 !important; background-color: transparent !important; ' + ("PRE" == format || "N" == format ? "font-size: 15px" : "font-weight: bold !important; ") + ("H1" == format ? "font-size: 2em !important; " : "") + ("H2" == format ? "font-size: 1.5em !important; " : "") + ("H3" == format ? "font-size: 1.17em !important; " : "") + ("H4" == format ? "font-size: 15px !important;" : "") + '"  role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="paragraphFormat" data-param1="' + format + '" title="' + this.language.translate(paragraphFormat[format]) + '">' + this.language.translate(paragraphFormat[format]) + "</a></" + ("N" == paragraphFormat ? this.html.defaultTag() || "DIV" : paragraphFormat) + "></li>";
            }
          }
          return html += "</ul>"
        },
        title: "Paragraph Format",
        callback: function (cmd, font) {
          this.paragraphFormat.apply(font)
          let blocks = this.selection.blocks();
          if (font === 'N') {
            for (let i = 0; i < blocks.length; i++) {
              let element = this.$(blocks[i]);
              if (element[0] && element[0].getAttribute('apply-class')) {
                element[0].className = element[0].getAttribute('apply-class');
                element[0].removeAttribute('apply-class')
              }
            }
          } else {
            for (let i = 0; i < blocks.length; i++) {
              let element = this.$(blocks[i]);
              if (element[0]) {
                let classes = element[0].className;
                if (classes.trim()) {
                  element[0].setAttribute('apply-class', classes.trim())
                  element[0].className = '';
                }
              }
            }
          }
        },
        refresh: function (element) {
          this.paragraphFormat.refresh(element)
        },
        refreshOnShow: function (element, t) {
          this.paragraphFormat.refreshOnShow(element, t)
        },
        plugin: "paragraphFormat"
      })
    }

    changeFontAtCaret(fontSize, fontFamily) {
        var span = this.froala.iframeDoc.createElement("span");
        span.style.fontWeight = "bold";
        if (fontSize) span.style.fontSize = fontSize;
        if (fontFamily) span.style.fontFamily = fontFamily;
        span.style.color = "red";

        if (this.froala.iframeDoc.contentWindow.getSelection) {
            var sel = this.froalaIframeWindow.getSelection();
            if (sel.rangeCount) {
                let range = sel.getRangeAt(0).cloneRange();
                range.surroundContents(span);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    }

    addCSSRule(sheet, selector, rules, index) {
      if("insertRule" in sheet) {
        sheet.insertRule(selector + "{" + rules + "}", index);
      }
      else if("addRule" in sheet) {
        sheet.addRule(selector, rules, index);
      }
    }

    removeCSSRule(sheet, selector, rules, index) {
      if("deleteRule" in sheet) {
        sheet.deleteRule(index);
      }
      else if("removeRule" in sheet) {
        sheet.removeRule(index);
      }
    }

    addCSSStyleLink(url) {
      let style = this.froala.iframeDoc.createElement("link");
      style.setAttribute('id', 'CCSStylesheetRuleStyle');
      style.setAttribute('rel', 'stylesheet');
      style.setAttribute('type', 'text/css');
      style.setAttribute('href', url);
      style.setAttribute('media', 'all');
      style.setAttribute('data-noprefix', '');
      this.froala.iframeDoc.head.appendChild(style); // must append before you can access sheet property
    }

    CCSStylesheetRuleStyle(document, stylesheet, selectorText, style, value, important) {
      /* returns the value of the element style of the rule in the stylesheet
      *  If no value is given, reads the value
      *  If value is given, the value is changed and returned
      *  If '' (empty string) is given, erases the value.
      *  The browser will apply the default one
      *
      * string stylesheet: part of the .css name to be recognized, e.g. 'default'
      * string selectorText: css selector, e.g. '#myId', '.myClass', 'thead td'
      * string style: camelCase element style, e.g. 'fontSize'
      * string value optional : the new value
      */
      let sheet = null;
      let CSSstyle = undefined, rules;
      for (const m of Object.keys(document.styleSheets)) {
        if (document.styleSheets[m].ownerNode && document.styleSheets[m].ownerNode.getAttribute('id') === 'CCSStylesheetRuleStyle') {
          sheet = document.styleSheets[m];
          break;
        }
      }

      if (!sheet) {
        let style = document.createElement("style");
        style.setAttribute('id', 'CCSStylesheetRuleStyle');
        document.head.appendChild(style); // must append before you can access sheet property
        sheet = style.sheet;
        this.addCSSRule(sheet, "body", "", 0);
        this.addCSSRule(sheet, "h1, h2, h3, h4, h5, h6", "", 0);
        this.addCSSRule(sheet, "h1", "", 0);
        this.addCSSRule(sheet, "h2", "", 0);
        this.addCSSRule(sheet, "h3", "", 0);
        this.addCSSRule(sheet, "h4", "", 0);
        this.addCSSRule(sheet, "h5", "", 0);
        this.addCSSRule(sheet, "h6", "", 0);
        this.addCSSRule(sheet, "a", "", 0);
        this.addCSSRule(sheet, "a.btn", "", 0);
        this.addCSSRule(sheet, "a.btn.btn-secondary", "", 0);
        this.addCSSRule(sheet, "a.btn:hover", "", 0);
        this.addCSSRule(sheet, "a.btn.btn-secondary:hover", "", 0);
        this.addCSSRule(sheet, "p", "", 0);
        this.addCSSRule(sheet, "button","", 0);
        this.addCSSRule(sheet, "button:hover", "", 0);
        this.addCSSRule(sheet, "section.fdb-block,header,footer","", 0);
      }
      const styleDashed = style.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
      if (sheet) {
        rules = sheet[document.all ? 'rules' : 'cssRules'];
        for (const n of Object.keys(rules)) {
          if (rules[n].selectorText === selectorText) {
            CSSstyle = rules[n].style;
            break;
          }
        }
      }

      if (CSSstyle) {
        if (value === undefined || value === '' || value === null) {
          CSSstyle.removeProperty(styleDashed);
          CSSstyle.removeProperty(style);
        } else {
          if (important) {
            CSSstyle.setProperty(styleDashed, value, 'important')
            setTimeout(() => {
              this.refreshSize();
            }, 500);
            return CSSstyle.setProperty(style, value, 'important')
          } else {
            CSSstyle[styleDashed] = value
            setTimeout(() => {
              this.refreshSize();
            }, 500);
            return CSSstyle[style] = value
          }
        }
      }
    }

    customStyleSheetToString() {
      let str = '<style id="CCSStylesheetRuleStyle">';
      Object.entries(this.customStyleSheet).forEach(([key, val]) => {
        str += key + '{';
        Object.entries(val).forEach(([key2, val2]) => {
          str += key2.split(/(?=[A-Z])/).join('-').toLowerCase() + ':' + val2 + ';';
        });
        str += '}';
      })
      str += '</style>';
      return str;
    }

  /**
   * body:marginTop
   * body:fontFamily
   * body:backgroundImage
   * h1-h6:color
   * h1-h6:fontFamily
   * a:color
   * button: backgroundColor
   * button: color
   * @param selector
   * @param name
   * @param value
   * @param important
   */
  changeStyle(selector, name, value, important) {
    if (!this.ready) {
      // Listen for the event.
      document.addEventListener('PageDesignerReady', (e) => { this.changeStyle(selector, name, value, important) }, false);
    } else {
      if (!this.customStyleSheet[selector]) this.customStyleSheet[selector] = {}
      if (value)
        this.customStyleSheet[selector][name] = value;
      else
        delete this.customStyleSheet[selector][name];
      this.CCSStylesheetRuleStyle(this.froala.iframeDoc, 'froala_style.css', selector, name, value, important);
    }
  }

  refreshSize() {
    if (!this.froala) return;
    this.froala.refreshIframeSize();
    if (this.editorHeight) {
      this.setEditorHeight();
    }
  }

  loadGoogleFont(name) {
    if (!this.ready) {
      // Listen for the event.
      document.addEventListener('PageDesignerReady', (e) => { this.loadGoogleFont(name) }, false);
    } else if (name) {
      if (!this.webFontLoadMonitorInstalled) {
        this.webFontLoadMonitorInstalled = false;
        let script = this.froala.iframeDoc.createElement("script");
        script.innerHTML = `
          function webFontLoadMonitor() {
            if (typeof WebFont !== 'undefined') {
              let event = new Event('webFontLoaded');
              document.dispatchEvent(event);
            } else {
              setTimeout(() => {
                webFontLoadMonitor();
              }, 500);
            }
          }
          webFontLoadMonitor();
        `;
        this.froala.iframeDoc.head.appendChild(script);
      }
      let script = this.froala.iframeDoc.createElement("script");
      script.innerHTML = `
          if (typeof WebFont !== 'undefined') {
            WebFont.load({google: {families: ['` + name + `']}});
          } else {
            document.addEventListener('webFontLoaded', function (e) {
              WebFont.load({google: {families: ['` + name + `']}});
            }, false);
          }
      `
      this.froala.iframeDoc.head.appendChild(script);
    }

  }

  hideBlockToolbars() {
    this.froala._hideBlocksToolbars();
  }

  getCustomCSSStyles() {
    let str = '<style id="CustomCssStyling">';
    str += this.customCSS;
    str += '</style>';
    return str;
  }

  customCSSStyles(value) {
    let document = this.froala.iframeDoc;
    let style = document.getElementById('CustomCssStyling');

    if (!style) {
      style = document.createElement("style");
      style.setAttribute('id', 'CustomCssStyling');
      document.head.appendChild(style); // must append before you can access sheet property
    }
    this.customCSS = value || '';
    style.innerHTML = value || '';
  }
}
